/* ==========================================================================
   AVENTURX — Esperienza mobile-first (script leggero, senza dipendenze)
   Si appoggia agli eventi del tema Mode: theme:open-cart-drawer,
   theme:cartchanged, on:variant:change.
   ========================================================================== */
(function () {
  'use strict';

  var mqMobile = window.matchMedia('(max-width: 767.98px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var body = document.body;

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function formatMoney(cents) {
    try {
      if (window.theme && theme.Shopify && theme.Shopify.formatMoney) {
        return theme.Shopify.formatMoney(cents, theme.money_format_with_product_code_preference || theme.money_format);
      }
    } catch (e) { /* formato di riserva sotto */ }
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  // sconto mostrato solo se almeno della soglia scelta nel tema (theme.axrMinDiscount, in %; 0 = sempre)
  function isSale(price, compare) {
    if (!compare || compare <= price) return false;
    var min = (window.theme && +window.theme.axrMinDiscount) || 0;
    return (compare - price) * 100 / compare >= min;
  }

  /* ---------- Header che si nasconde scorrendo (mobile) ---------- */
  function initAutohideHeader() {
    if (!body.classList.contains('axr-autohide-header')) return;
    var header = document.querySelector('.section-header');
    if (!header) return;
    var lastY = window.scrollY;
    var ticking = false;
    var hidden = false;

    function headerHeight() { return header.offsetHeight || 0; }

    function setHidden(state) {
      if (state === hidden) return;
      hidden = state;
      body.classList.toggle('axr-header-hidden', state);
      document.documentElement.style.setProperty('--axr-toolbar-top', state ? '0px' : headerHeight() + 'px');
    }

    function update() {
      ticking = false;
      var y = window.scrollY;
      if (!mqMobile.matches || body.classList.contains('reveal-mobile-nav') || document.querySelector('.header-search-content:not(.hidden)')) {
        setHidden(false);
        lastY = y;
        return;
      }
      var delta = y - lastY;
      if (y < headerHeight() + 40) setHidden(false);
      else if (delta > 6) setHidden(true);
      else if (delta < -6) setHidden(false);
      lastY = y;
    }

    document.documentElement.style.setProperty('--axr-toolbar-top', headerHeight() + 'px');
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (!hidden) document.documentElement.style.setProperty('--axr-toolbar-top', headerHeight() + 'px');
    });
    // se l'header contiene il focus (es. tastiera) resta visibile
    header.addEventListener('focusin', function () { setHidden(false); });
  }

  /* ---------- Ricerca aperta: nasconde la barra di ricerca dell'header (resta solo quella attiva) ---------- */
  function initSearchState() {
    var content = document.getElementById('content');
    if (!content) return;
    var watched = null;
    function sync() {
      var panel = content.querySelector(':scope > .header-search-content');
      if (panel && panel !== watched) {
        watched = panel;
        new MutationObserver(sync).observe(panel, { attributes: true, attributeFilter: ['class'] });
      }
      body.classList.toggle('axr-search-open', !!(panel && !panel.classList.contains('hidden')));
    }
    // il pannello di ricerca viene inserito in #content alla prima apertura
    new MutationObserver(sync).observe(content, { childList: true });
  }

  /* ---------- Barra di navigazione in basso ---------- */
  function initBottomNav() {
    var nav = document.querySelector('[data-axr-bottom-nav]');
    if (!nav) return;

    nav.addEventListener('click', function (evt) {
      var menuBtn = evt.target.closest('[data-axr-open-menu]');
      var searchBtn = evt.target.closest('[data-axr-open-search]');
      var cartBtn = evt.target.closest('[data-axr-open-cart]');

      if (menuBtn) {
        var toggle = document.querySelector('.section-header .mobile-nav-toggle');
        if (toggle) { evt.preventDefault(); toggle.click(); }
        else window.location.href = '/collections';
        return;
      }
      if (searchBtn) {
        var searchLink = document.querySelector('.section-header .show-search-link');
        if (searchLink && document.querySelector('.section-header .header-search-template')) {
          evt.preventDefault();
          body.classList.remove('axr-header-hidden');
          window.scrollTo({ top: 0, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
          searchLink.click();
        }
        return;
      }
      if (cartBtn && window.theme && theme.settings && theme.settings.cart_type === 'drawer' && document.querySelector('.cart-drawer')) {
        evt.preventDefault();
        document.dispatchEvent(new CustomEvent('theme:open-cart-drawer', { bubbles: true, cancelable: false }));
      }
    });

    // Nasconde la barra quando la tastiera è aperta (campo di testo attivo)
    document.addEventListener('focusin', function (evt) {
      if (evt.target.matches && evt.target.matches('input:not([type="checkbox"]):not([type="radio"]):not([type="submit"]), textarea, select')) {
        body.classList.add('axr-hide-bottom-nav');
      }
    });
    document.addEventListener('focusout', function () { body.classList.remove('axr-hide-bottom-nav'); });
  }

  /* ---------- Contatore carrello (barra in basso) ---------- */
  function updateCartCount() {
    var counters = document.querySelectorAll('[data-axr-cart-count]');
    if (!counters.length) return;
    fetch((window.theme && theme.routes ? theme.routes.cart_url : '/cart') + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        counters.forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
      })
      .catch(function () {});
  }
  document.addEventListener('theme:cartchanged', updateCartCount);

  /* ---------- Footer ad accordion su mobile ---------- */
  function initFooterAccordion() {
    var blocks = document.querySelectorAll('.axr-ux .section-footer__menu-block');
    blocks.forEach(function (block, i) {
      var title = block.querySelector('.section-footer__title');
      var menu = block.querySelector('.section-footer__menu-block__menu');
      if (!title || !menu) return;
      block.classList.add('axr-collapsible');
      var id = menu.id || ('axr-footer-menu-' + i);
      menu.id = id;
      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');
      title.setAttribute('aria-controls', id);
      title.setAttribute('aria-expanded', 'false');
      function toggle() {
        if (!mqMobile.matches) return;
        var open = block.classList.toggle('axr-open');
        title.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      title.addEventListener('click', toggle);
      title.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });
  }

  /* ---------- Rail orizzontali: frecce desktop + barra di avanzamento ---------- */
  function initRail(wrap) {
    if (wrap.dataset.axrRailReady) return;
    wrap.dataset.axrRailReady = '1';
    var track = wrap.querySelector('.axr-rail');
    if (!track) return;
    var prev = wrap.querySelector('.axr-rail-nav--prev');
    var next = wrap.querySelector('.axr-rail-nav--next');
    var bar = wrap.querySelector('.axr-rail-progress span');

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= max - 4;
      if (bar) {
        var visible = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
        var w = Math.max(.12, Math.min(1, visible));
        bar.style.width = (w * 100) + '%';
        bar.style.marginLeft = max > 0 ? ((track.scrollLeft / max) * (1 - w) * 100) + '%' : '0';
        bar.parentNode.style.visibility = max > 4 ? '' : 'hidden';
      }
    }
    function step(dir) {
      var item = track.firstElementChild;
      var amount = item ? item.getBoundingClientRect().width * 2 : track.clientWidth * .8;
      track.scrollBy({ left: dir * amount, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
    wrap.axrRailUpdate = update;
  }

  /* ---------- Tab prodotti ---------- */
  function initTabs(root) {
    if (root.dataset.axrTabsReady) return;
    root.dataset.axrTabsReady = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = root.querySelectorAll('[role="tabpanel"]');
    var viewAll = root.querySelector('[data-axr-tabs-view-all]');

    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p) {
        var on = p.id === tab.getAttribute('aria-controls');
        p.hidden = !on;
        if (on) {
          p.querySelectorAll('product-block[manual-load]').forEach(function (b) { if (b.init && !b.dataset.axrInit) { b.dataset.axrInit = '1'; b.init(); } });
          var rail = p.querySelector('.axr-rail-wrap');
          if (rail && rail.axrRailUpdate) rail.axrRailUpdate();
        }
      });
      if (viewAll && tab.dataset.url) viewAll.href = tab.dataset.url;
      if (focus) tab.focus();
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (n) { e.preventDefault(); select(n, true); }
      });
    });
  }

  /* ---------- Hero slider ---------- */
  function initHero(hero) {
    if (hero.dataset.axrHeroReady) return;
    hero.dataset.axrHeroReady = '1';
    var track = hero.querySelector('.axr-hero__track');
    var slides = hero.querySelectorAll('.axr-hero__slide');
    var dots = hero.querySelectorAll('.axr-hero__dot');
    if (!track || slides.length < 2) return;
    var interval = parseInt(hero.dataset.interval || '6', 10) * 1000;
    var autoplay = hero.dataset.autoplay === 'true' && !reduceMotion.matches;
    var current = 0;
    var timer = null;

    function setActive(i) {
      current = i;
      dots.forEach(function (d, j) {
        d.classList.toggle('is-active', j === i);
        d.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
      slides.forEach(function (s, j) { s.setAttribute('aria-hidden', j === i ? 'false' : 'true'); s.tabIndex = -1; });
    }
    function goTo(i) {
      track.scrollTo({ left: slides[i].offsetLeft, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }
    function schedule() {
      clearTimeout(timer);
      if (!autoplay || hero.classList.contains('is-paused')) return;
      // riavvia l'animazione della barretta
      var dot = dots[current];
      if (dot) { dot.classList.remove('is-active'); void dot.offsetWidth; dot.classList.add('is-active'); }
      timer = setTimeout(function () { goTo((current + 1) % slides.length); }, interval);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting && en.intersectionRatio > .6) {
          var i = Array.prototype.indexOf.call(slides, en.target);
          if (i !== current) { setActive(i); }
          schedule();
        }
      });
    }, { root: track, threshold: [.6] });
    slides.forEach(function (s) { io.observe(s); });

    dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
    ['pointerdown', 'focusin'].forEach(function (ev) {
      hero.addEventListener(ev, function () { hero.classList.add('is-paused'); clearTimeout(timer); });
    });
    if (autoplay) hero.classList.add('is-autoplay');
    // si ferma quando l'hero non è visibile
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) schedule(); else clearTimeout(timer); });
    }).observe(hero);
    setActive(0);
  }

  /* ---------- Pagina collezione: ordina + ombra toolbar ---------- */
  function initCollectionToolbar(root) {
    var toolbar = root.querySelector('.axr-coll-toolbar');
    if (!toolbar || toolbar.dataset.axrReady) return;
    toolbar.dataset.axrReady = '1';
    var sentinel = document.createElement('div');
    sentinel.style.height = '1px';
    toolbar.parentNode.insertBefore(sentinel, toolbar);
    new IntersectionObserver(function (entries) {
      toolbar.classList.toggle('is-stuck', !entries[0].isIntersecting);
    }).observe(sentinel);
  }

  // Ordina: delegato perché la tendina viene sostituita dai filtri AJAX del tema
  document.addEventListener('change', function (evt) {
    var select = evt.target.closest && evt.target.closest('[data-axr-sort]');
    if (!select) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------- Testi lunghi richiudibili (descrizione collezione) ---------- */
  function initClamp(root) {
    root.querySelectorAll('[data-axr-clamp]').forEach(function (box) {
      if (box.dataset.axrClampReady) return;
      box.dataset.axrClampReady = '1';
      var inner = box.firstElementChild;
      var btn = box.querySelector('[data-axr-clamp-toggle]');
      if (!inner || !btn) return;
      box.classList.add('is-clamped');
      if (inner.scrollHeight <= inner.clientHeight + 4) { box.classList.remove('is-clamped'); return; }
      btn.hidden = false;
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var open = box.classList.toggle('is-open');
        btn.textContent = open ? btn.dataset.less : btn.dataset.more;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- Barra di acquisto fissa (mobile) ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-axr-sticky-atc]');
    if (!bar) return;
    var section = bar.closest('[data-section-type="main-product"]') || document;
    var detail = section.querySelector('.product-detail');
    if (!detail) return;
    var buyRow = detail.querySelector('.buy-buttons-row');
    var btn = bar.querySelector('[data-axr-sticky-btn]');
    var priceEl = bar.querySelector('[data-axr-sticky-price]');
    var compareEl = bar.querySelector('[data-axr-sticky-compare]');
    var variantEl = bar.querySelector('[data-axr-sticky-variant]');
    var imgEl = bar.querySelector('[data-axr-sticky-img]');
    if (!buyRow || !btn) { bar.remove(); return; }

    var needsChoice = bar.dataset.needsChoice === 'true';
    var chosen = !needsChoice;
    var labels = { choose: bar.dataset.labelChoose, add: bar.dataset.labelAdd, soldout: bar.dataset.labelSoldout };

    function mainButton() { return detail.querySelector('.buy-buttons-row button[name="add"]'); }

    function refreshButton() {
      var main = mainButton();
      var soldOut = main && main.disabled && !main.classList.contains('btn--in-progress');
      if (!chosen) {
        btn.textContent = labels.choose;
        btn.classList.remove('is-disabled');
      } else if (soldOut) {
        btn.textContent = labels.soldout;
        btn.classList.add('is-disabled');
      } else {
        btn.textContent = labels.add;
        btn.classList.remove('is-disabled');
      }
    }

    btn.addEventListener('click', function () {
      if (!chosen) {
        var picker = detail.querySelector('variant-picker [data-option="' + (bar.dataset.chooseOption || '').replace(/"/g, '\\"') + '"]') || detail.querySelector('variant-picker');
        if (picker) {
          picker.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
          picker.classList.remove('axr-attention');
          void picker.offsetWidth;
          picker.classList.add('axr-attention');
        }
        return;
      }
      var main = mainButton();
      if (main && !main.disabled) main.click();
    });

    section.addEventListener('on:variant:change', function (evt) {
      chosen = true;
      var v = evt.detail && evt.detail.variant;
      if (v) {
        if (priceEl) {
          priceEl.textContent = formatMoney(v.price);
          priceEl.classList.toggle('is-sale', isSale(v.price, v.compare_at_price));
        }
        if (compareEl) compareEl.textContent = isSale(v.price, v.compare_at_price) ? formatMoney(v.compare_at_price) : '';
        if (variantEl) variantEl.textContent = v.title && v.title !== 'Default Title' ? v.title : '';
        if (imgEl && v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) {
          var src = v.featured_media.preview_image.src;
          imgEl.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        }
      }
      setTimeout(refreshButton, 60);
    });

    // scelta fatta dal cliente: la barra lo sa subito, senza aspettare la risposta del negozio
    detail.addEventListener('change', function (evt) {
      if (evt.target && evt.target.matches && evt.target.matches('variant-picker .js-option')) {
        chosen = true;
        setTimeout(refreshButton, 60);
      }
    });

    // il pulsante principale viene sostituito al cambio variante: osserviamo la riga
    new MutationObserver(function () { refreshButton(); }).observe(buyRow, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'class'] });

    var scrolled = false;
    var buyVisible = true;
    function toggleBar() {
      var show = mqMobile.matches && scrolled && !buyVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      body.classList.toggle('axr-sticky-atc-on', show);
    }
    new IntersectionObserver(function (entries) {
      buyVisible = entries[0].isIntersecting;
      toggleBar();
    }, { rootMargin: '0px 0px -40px 0px' }).observe(buyRow);
    window.addEventListener('scroll', function () {
      var s = window.scrollY > 240;
      if (s !== scrolled) { scrolled = s; toggleBar(); }
    }, { passive: true });
    refreshButton();
  }

  /* ==========================================================================
     LA MIA MOTO — configuratore (tipo → marca → modello → anno)
     La scelta resta sul dispositivo del cliente (localStorage) e alimenta header,
     barra nelle collezioni, link filtrati e verifica di compatibilità del prodotto.
     ========================================================================== */
  var Moto = (function () {
    var KEY = 'axr_moto';
    var root = null;
    var cfg = {};
    var data = null;
    var dataPromise = null;
    var draft = {};
    var history = [];
    var lastFocus = null;

    function read() {
      try { var v = JSON.parse(window.localStorage.getItem(KEY) || 'null'); return v && typeof v === 'object' ? v : null; } catch (e) { return null; }
    }
    function write(m) {
      try { if (m) window.localStorage.setItem(KEY, JSON.stringify(m)); else window.localStorage.removeItem(KEY); } catch (e) { /* storage non disponibile: la scelta vale solo per questa pagina */ }
      current = m;
      refresh();
    }
    var current = read();

    function handle(s) {
      return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }
    function bikeName(m) {
      if (!m) return '';
      if (m.brand && m.model) return m.brand + ' ' + m.model;
      return m.brand || m.type || '';
    }
    function bikeMeta(m) {
      if (!m) return '';
      return [m.type, m.year].filter(Boolean).join(' · ');
    }
    // icona per tipo di moto (stessa regola di snippets/axr-moto-icon.liquid)
    var ICON_RULES = [
      ['moto-adventure', /adventure|crossover|stradal|maxi enduro|travel/],
      ['moto-cross', /cross|enduro|motard|trial|off/],
      ['moto-scooter', /scooter/],
      ['moto-touring', /tour|turismo/],
      ['moto-custom', /custom|cruiser|chopper|bobber/],
      ['moto-sport', /sport|racing|pista/],
      ['moto-naked', /naked|roadster|street|classic|cafe|café|scrambler/]
    ];
    function iconFor(type) {
      var t = String(type || '').toLowerCase();
      for (var i = 0; i < ICON_RULES.length; i++) if (ICON_RULES[i][1].test(t)) return ICON_RULES[i][0];
      return 'moto';
    }
    var iconTpl = null;
    function iconSvg(name) {
      if (!iconTpl || !iconTpl.isConnected) iconTpl = document.querySelector('template[data-axr-moto-icons]');
      if (!iconTpl) return null;
      var svg = iconTpl.content.querySelector('[data-icon="' + name + '"] svg') || iconTpl.content.querySelector('[data-icon="moto"] svg');
      return svg ? svg.cloneNode(true) : null;
    }
    function setIcon(el, type) {
      var name = iconFor(type);
      if (el.getAttribute('data-icon') === name) return;
      var svg = iconSvg(name);
      if (!svg) return;
      var old = el.querySelector('svg');
      if (old) {
        svg.setAttribute('width', old.getAttribute('width'));
        svg.setAttribute('height', old.getAttribute('height'));
        el.replaceChild(svg, old);
      } else {
        el.appendChild(svg);
      }
      el.setAttribute('data-icon', name);
    }

    function fitTag(m) {
      if (!m || !m.brand) return '';
      return cfg.prefix + handle(m.brand) + (m.model ? '_' + handle(m.model) : '');
    }
    function typeUrl(type, base) {
      var url = new URL(base || cfg.typeBase || '/collections/all', window.location.origin);
      url.searchParams.delete(cfg.typeParam);
      url.searchParams.delete('page');
      url.searchParams.append(cfg.typeParam, type);
      return url.pathname + url.search;
    }
    function fitmentUrl(m) {
      if (!cfg.fitmentUrl || !m || !m.brand) return '';
      return cfg.fitmentUrl
        .replace(/\{tag\}/g, encodeURIComponent(fitTag(m)))
        .replace(/\{marca\}/g, encodeURIComponent(handle(m.brand)))
        .replace(/\{modello\}/g, encodeURIComponent(handle(m.model)))
        .replace(/\{anno\}/g, encodeURIComponent(m.year || ''))
        .replace(/\{tipo\}/g, encodeURIComponent(m.type || ''));
    }

    /* ---- aggiornamento dei punti della pagina che mostrano la moto ---- */
    function refresh(scope) {
      var r = scope || document;
      var name = bikeName(current);
      body.classList.toggle('axr-has-moto', !!name);
      r.querySelectorAll('[data-axr-moto-label]').forEach(function (el) {
        el.textContent = name || el.getAttribute('data-axr-moto-label-empty') || cfg.labelDefault || el.textContent;
      });
      r.querySelectorAll('[data-axr-moto-sub]').forEach(function (el) {
        el.textContent = name ? (bikeMeta(current) || el.getAttribute('data-empty')) : el.getAttribute('data-empty');
      });
      r.querySelectorAll('[data-axr-moto-icon]').forEach(function (el) { setIcon(el, current && current.type); });
      r.querySelectorAll('[data-axr-moto-bar]').forEach(updateBar);
      r.querySelectorAll('[data-axr-fitment]').forEach(updateFitment);
    }

    function updateBar(bar) {
      var link = bar.querySelector('[data-axr-moto-filter-link]');
      bar.classList.toggle('has-moto', !!current);
      if (!link) return;
      var available = bar.getAttribute('data-filter-available') === 'true';
      if (!available || !current || !current.type) { link.hidden = true; return; }
      var param = bar.getAttribute('data-param');
      var active = (bar.getAttribute('data-active') || '').split('|').filter(Boolean);
      var url = new URL(window.location.href);
      url.searchParams.delete('page');
      if (active.indexOf(current.type) > -1) {
        url.searchParams.delete(param);
        link.textContent = '✓ ' + current.type + ' ✕';
        link.classList.add('is-active');
      } else {
        url.searchParams.delete(param);
        url.searchParams.append(param, current.type);
        link.textContent = (cfg.labelOnlyType || '__TYPE__').replace('__TYPE__', current.type);
        link.classList.remove('is-active');
      }
      link.href = url.pathname + url.search;
      link.hidden = false;
    }

    function updateFitment(box) {
      var tags = (box.getAttribute('data-tags') || '').split('|').filter(Boolean);
      var title = box.querySelector('[data-axr-fitment-title]');
      var text = box.querySelector('[data-axr-fitment-text]');
      var btn = box.querySelector('[data-axr-fitment-btn]');
      box.classList.remove('is-ok', 'is-ko');
      if (!current || !current.brand) {
        title.textContent = box.getAttribute('data-title-check');
        text.textContent = box.getAttribute('data-text-check');
        text.hidden = false;
        btn.textContent = box.getAttribute('data-btn-select');
        return;
      }
      var full = fitTag(current);
      var brandOnly = cfg.prefix + handle(current.brand);
      var ok = tags.indexOf(full) > -1 || tags.indexOf(brandOnly) > -1;
      var name = bikeName(current);
      box.classList.add(ok ? 'is-ok' : 'is-ko');
      title.textContent = box.getAttribute(ok ? 'data-title-ok' : 'data-title-ko').replace('__BIKE__', name);
      btn.textContent = box.getAttribute('data-btn-change');
      if (ok) {
        text.hidden = true;
      } else {
        text.hidden = false;
        text.textContent = '';
        var href = fitmentUrl(current);
        if (href) {
          var a = document.createElement('a');
          a.href = href;
          a.textContent = box.getAttribute('data-text-ko');
          text.appendChild(a);
        }
      }
    }

    /* ---- dati marche/modelli (caricati solo all'apertura) ---- */
    function loadData() {
      if (data) return Promise.resolve(data);
      if (!dataPromise) {
        dataPromise = fetch(cfg.dataUrl, { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (d) { data = d; return d; })
          .catch(function () { data = { brands: [] }; return data; });
      }
      return dataPromise;
    }

    function optionButton(kind, value, label, sub, iconType) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'axr-moto__opt';
      b.setAttribute('data-axr-moto-pick', kind);
      b.setAttribute('data-value', value);
      if (iconType !== undefined) {
        var ico = iconSvg(iconFor(iconType));
        if (ico) {
          ico.setAttribute('width', '34');
          ico.setAttribute('height', '34');
          ico.classList.add('axr-moto__opt-icon');
          b.classList.add('has-icon');
          b.appendChild(ico);
        }
      }
      var s = document.createElement('span');
      s.textContent = label;
      b.appendChild(s);
      if (sub) {
        var m = document.createElement('small');
        m.textContent = sub;
        b.appendChild(m);
      }
      return b;
    }

    function renderBrands() {
      var list = root.querySelector('[data-axr-moto-list="brand"]');
      loadData().then(function (d) {
        list.textContent = '';
        (d.brands || []).forEach(function (br) { list.appendChild(optionButton('brand', br.name, br.name)); });
        applyFilter('brand');
      });
    }
    function renderModels() {
      var list = root.querySelector('[data-axr-moto-list="model"]');
      list.textContent = '';
      loadData().then(function (d) {
        var brand = (d.brands || []).filter(function (b) { return b.name === draft.brand; })[0];
        var models = brand ? brand.models : [];
        models.forEach(function (m) {
          var b = optionButton('model', m[0], m[0], m[1], m[1] || '');
          b.setAttribute('data-type', m[1] || '');
          list.appendChild(b);
        });
        applyFilter('model');
      });
    }
    function renderYears() {
      var list = root.querySelector('[data-axr-moto-list="year"]');
      if (list.childElementCount) return;
      var y = new Date().getFullYear() + 1;
      for (var i = y; i >= 1990; i--) list.appendChild(optionButton('year', String(i), String(i)));
    }
    function applyFilter(kind) {
      var input = root.querySelector('[data-axr-moto-filter="' + kind + '"]');
      var q = handle(input ? input.value : '');
      root.querySelectorAll('[data-axr-moto-list="' + kind + '"] .axr-moto__opt').forEach(function (b) {
        b.hidden = q && handle(b.getAttribute('data-value')).indexOf(q) === -1;
      });
    }

    /* ---- navigazione tra i passaggi ---- */
    var ORDER = ['type', 'brand', 'model', 'year', 'done'];
    function show(step, push) {
      if (push !== false) history.push(step);
      root.querySelectorAll('[data-step]').forEach(function (s) { s.hidden = s.getAttribute('data-step') !== step; });
      var idx = ORDER.indexOf(step);
      root.querySelectorAll('[data-step-dot]').forEach(function (d) {
        var i = ORDER.indexOf(d.getAttribute('data-step-dot'));
        d.classList.toggle('is-done', i < idx);
        d.classList.toggle('is-current', i === idx);
      });
      root.querySelector('.axr-moto__steps').hidden = step === 'done';
      root.querySelector('[data-axr-moto-back]').hidden = history.length < 2;
      if (step === 'brand') renderBrands();
      if (step === 'model') renderModels();
      if (step === 'year') renderYears();
      if (step === 'done') renderSummary();
      root.querySelectorAll('[data-step="' + step + '"] [data-axr-moto-pick]').forEach(function (b) {
        b.classList.toggle('is-selected', draft[b.getAttribute('data-axr-moto-pick')] === b.getAttribute('data-value'));
      });
      var first = root.querySelector('[data-step="' + step + '"] input, [data-step="' + step + '"] button');
      if (first && !mqMobile.matches) first.focus({ preventScroll: true });
      var bodyEl = root.querySelector('.axr-moto__body');
      if (bodyEl) bodyEl.scrollTop = 0;
    }
    function renderSummary() {
      var m = current || draft;
      root.querySelector('[data-axr-moto-summary-name]').textContent = bikeName(m) || cfg.labelDefault;
      root.querySelector('[data-axr-moto-summary-meta]').textContent = bikeMeta(m);
      var summaryIcon = root.querySelector('.axr-moto__summary-icon [data-axr-moto-icon]');
      if (summaryIcon) setIcon(summaryIcon, m.type);
      var typeCta = root.querySelector('[data-axr-moto-cta="type"]');
      var fitCta = root.querySelector('[data-axr-moto-cta="fitment"]');
      if (m.type) {
        typeCta.href = typeUrl(m.type);
        typeCta.textContent = (cfg.labelTypeCta || '__TYPE__').replace('__TYPE__', m.type);
        typeCta.hidden = false;
      } else typeCta.hidden = true;
      var f = fitmentUrl(m);
      fitCta.hidden = !(f && m.model);
      if (f) fitCta.href = f;
    }

    function save() {
      draft.savedAt = Date.now();
      write(Object.assign({}, draft));
    }
    function pick(kind, value, el) {
      if (kind === 'type') { draft.type = value; save(); show('brand'); return; }
      if (kind === 'brand') {
        if (draft.brand !== value) { draft.model = ''; draft.year = ''; }
        draft.brand = value;
        save();
        var mi = root.querySelector('[data-axr-moto-filter="model"]');
        if (mi) mi.value = '';
        show('model');
        return;
      }
      if (kind === 'model') {
        draft.model = value;
        // il tipo del modello scelto vale più di quello indicato all'inizio (es. Naked → BMW R 1300 GS = Adventure)
        var t = el && el.getAttribute('data-type');
        if (t) draft.type = t;
        save();
        show('year');
        return;
      }
      if (kind === 'year') {
        draft.year = value;
        save();
        show('done');
      }
    }

    function open(evt) {
      if (!root) return;
      if (evt) evt.preventDefault();
      lastFocus = document.activeElement;
      draft = Object.assign({}, current || {});
      history = [];
      root.hidden = false;
      document.documentElement.classList.add('axr-moto-open');
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      show(current ? 'done' : 'type');
      root.querySelector('.axr-moto__sheet').focus({ preventScroll: true });
    }
    function close() {
      if (!root || root.hidden) return;
      root.classList.remove('is-open');
      document.documentElement.classList.remove('axr-moto-open');
      setTimeout(function () { root.hidden = true; }, reduceMotion.matches ? 0 : 250);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    function init() {
      root = document.querySelector('[data-axr-moto-root]');
      if (root) {
        cfg = {
          dataUrl: root.getAttribute('data-data-url'),
          typeParam: root.getAttribute('data-type-param') || 'filter.p.m.custom.tipo_moto',
          typeBase: root.getAttribute('data-type-base'),
          fitmentUrl: root.getAttribute('data-fitment-url'),
          prefix: (root.getAttribute('data-tag-prefix') || 'moto_').toLowerCase(),
          labelDefault: root.getAttribute('data-label-default'),
          labelTypeCta: root.getAttribute('data-label-type-cta'),
          labelOnlyType: root.getAttribute('data-label-only-type')
        };
        root.addEventListener('click', function (evt) {
          var t = evt.target;
          if (t.closest('[data-axr-moto-close]')) { close(); return; }
          if (t.closest('[data-axr-moto-back]')) { history.pop(); show(history[history.length - 1] || 'type', false); return; }
          var go = t.closest('[data-axr-moto-go]');
          if (go) {
            var step = go.getAttribute('data-axr-moto-go');
            if (step === 'type') { draft = {}; history = []; }
            show(step);
            return;
          }
          if (t.closest('[data-axr-moto-clear]')) { write(null); draft = {}; history = []; show('type'); return; }
          var p = t.closest('[data-axr-moto-pick]');
          if (p) pick(p.getAttribute('data-axr-moto-pick'), p.getAttribute('data-value'), p);
        });
        root.addEventListener('input', function (evt) {
          var k = evt.target.getAttribute('data-axr-moto-filter');
          if (k) applyFilter(k);
        });
        root.querySelector('[data-axr-moto-custom]').addEventListener('submit', function (evt) {
          evt.preventDefault();
          var v = evt.target.querySelector('input').value.trim();
          if (v) pick('model', v, null);
        });
        document.addEventListener('keydown', function (evt) {
          if (evt.key === 'Escape' && !root.hidden) close();
        });
      }

      document.addEventListener('click', function (evt) {
        var opener = evt.target.closest && evt.target.closest('[data-axr-moto-open]');
        if (opener && root) { open(evt); return; }
        var setType = evt.target.closest && evt.target.closest('[data-axr-moto-set-type]');
        if (setType) {
          var m = Object.assign({}, current || {});
          m.type = setType.getAttribute('data-axr-moto-set-type');
          write(m);
        }
      });

      // L'header viene in parte ricaricato dal tema (es. dopo l'aggiunta al carrello)
      var header = document.querySelector('.section-header');
      if (header) {
        var t = null;
        new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { refresh(header); }, 50); })
          .observe(header, { childList: true, subtree: true });
      }
      refresh();
    }

    return { init: init, refresh: refresh };
  })();

  /* ---------- Popup informativi (garanzie, vantaggi): elemento <dialog> del browser ----------
     Aperti con show() e non showModal(): restano finestre normali della pagina, fuori dal "livello superiore"
     del browser, così i gestori di password (Bitwarden) non li scambiano per un'interferenza.
     Esc, tocco fuori e focus che resta nella finestra sono gestiti qui. */
  var Pop = (function () {
    var opener = null;
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
    function focusables(dlg) {
      return Array.prototype.filter.call(dlg.querySelectorAll(FOCUSABLE), function (el) { return el.offsetParent !== null; });
    }
    function open(id, trigger) {
      var dlg = document.getElementById(id);
      if (!dlg || dlg.tagName !== 'DIALOG') return false;
      // fuori dai contenitori della pagina (animazioni, trasformazioni): la finestra resta fissa sullo schermo
      if (dlg.parentNode !== body) {
        document.querySelectorAll('body > dialog.axr-pop').forEach(function (o) { if (o.id === id && o !== dlg) o.remove(); });
        body.appendChild(dlg);
      }
      opener = trigger || null;
      if (!dlg.open) {
        if (typeof dlg.show === 'function') dlg.show();
        else dlg.setAttribute('open', '');
      }
      body.classList.add('axr-pop-open');
      var close = dlg.querySelector('[data-axr-pop-close]');
      if (close) close.focus({ preventScroll: true });
      return true;
    }
    function close(dlg) {
      if (!dlg || !dlg.open) return;
      var done = function () {
        dlg.classList.remove('is-closing');
        if (typeof dlg.close === 'function') dlg.close();
        else { dlg.removeAttribute('open'); dlg.dispatchEvent(new Event('close')); }
      };
      if (reduceMotion.matches) { done(); return; }
      dlg.classList.add('is-closing');
      setTimeout(done, 180);
    }
    function init() {
      document.addEventListener('click', function (evt) {
        var trigger = evt.target.closest('[data-axr-pop]');
        if (trigger) {
          if (open(trigger.getAttribute('data-axr-pop'), trigger)) evt.preventDefault();
          return;
        }
        var btn = evt.target.closest('[data-axr-pop-close]');
        if (btn) { close(btn.closest('dialog')); return; }
        // tocco sullo sfondo scuro: il clic arriva al <dialog> stesso, fuori dal riquadro
        if (evt.target.matches && evt.target.matches('dialog.axr-pop')) close(evt.target);
      });
      // Esc chiude; Tab resta dentro la finestra aperta
      document.addEventListener('keydown', function (evt) {
        var dlg = document.querySelector('dialog.axr-pop[open]');
        if (!dlg) return;
        if (evt.key === 'Escape') { evt.preventDefault(); close(dlg); return; }
        if (evt.key !== 'Tab') return;
        var items = focusables(dlg);
        if (!items.length) return;
        var first = items[0], last = items[items.length - 1];
        if (!dlg.contains(document.activeElement)) { evt.preventDefault(); first.focus(); }
        else if (evt.shiftKey && document.activeElement === first) { evt.preventDefault(); last.focus(); }
        else if (!evt.shiftKey && document.activeElement === last) { evt.preventDefault(); first.focus(); }
      });
      document.addEventListener('close', function (evt) {
        if (!(evt.target.matches && evt.target.matches('dialog.axr-pop'))) return;
        if (!document.querySelector('dialog.axr-pop[open]')) body.classList.remove('axr-pop-open');
        if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
        opener = null;
      }, true);
    }
    return { init: init, open: open };
  })();

  /* ---------- Chat del sito al posto di WhatsApp (Impostazioni tema → Aventurx — Chat) ----------
     I pulsanti con data-axr-chat, i link "#chat" e tutti i link WhatsApp (wa.me, api.whatsapp.com) aprono la
     chat dello script nel layout (window.AventurxChat). Lo script si carica in differita: se non è ancora
     pronto si aspetta un poco; se non arriva si apre il link di riserva (WhatsApp come prima). */
  var Chat = (function () {
    var WAIT = 2500;
    function api() { return window.AventurxChat && typeof window.AventurxChat.open === 'function' ? window.AventurxChat : null; }
    function fallbackOf(el) {
      var fb = el.getAttribute('data-axr-chat-fallback') || '';
      var href = el.getAttribute('href') || '';
      if (!fb && /wa\.me|whatsapp\.com/i.test(href)) fb = href;
      return fb || (window.axrChat && window.axrChat.fallback) || '';
    }
    function open(fallback) {
      var a = api();
      if (a) { a.open(); return; }
      var start = Date.now();
      (function wait() {
        var b = api();
        if (b) { b.open(); return; }
        if (Date.now() - start < WAIT) { setTimeout(wait, 150); return; }
        if (fallback) window.open(fallback, '_blank', 'noopener');
      })();
    }
    function init() {
      if (!window.axrChat || !window.axrChat.on) return;
      document.addEventListener('click', function (evt) {
        if (evt.defaultPrevented || evt.button !== 0 || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;
        var el = evt.target.closest('[data-axr-chat], a[href="#chat"], a[href*="wa.me/"], a[href*="api.whatsapp.com"], a[href*="whatsapp.com/send"]');
        if (!el) return;
        evt.preventDefault();
        // menu o finestre aperti: si chiudono prima di aprire la chat
        if (body.classList.contains('axr-menu-open') && typeof Menu !== 'undefined' && Menu.close) Menu.close();
        open(fallbackOf(el));
      });
    }
    return { init: init, open: open };
  })();

  /* ---------- Pop-up della newsletter (sections/popup.liquid): quando compare ----------
     Con "Usa le regole Aventurx" il tema non lo apre da solo: qui si apre al primo evento attivo tra
     secondi sulla pagina, percentuale di pagina scorsa e uscita dalla pagina (computer: mouse verso l'alto
     fuori dalla finestra; telefono: ritorno veloce verso l'alto dopo aver scorso). Pagine e clienti li
     sceglie già il Liquid. Rispetta "Frequency" (giorni dopo la chiusura) e la modalità test. */
  var PopupRules = (function () {
    var DISMISSED = 'cc-theme-popup-dismissed';
    var VIEWS = 'axr_pop_views';
    function read(key) { try { return window.localStorage.getItem(key); } catch (e) { return null; } }
    function write(key, val) { try { window.localStorage.setItem(key, val); } catch (e) { /* memoria non disponibile */ } }
    function init() {
      var el = document.querySelector('[data-section-type="newsletter-popup"][data-axr-rules="true"]');
      if (!el || (window.Shopify && window.Shopify.designMode)) return;
      var views = (parseInt(read(VIEWS), 10) || 0) + 1;
      write(VIEWS, String(views));
      var test = el.getAttribute('data-test-mode') === 'true';
      if (!test) {
        var days = parseFloat(el.getAttribute('data-dismiss-for-days')) || 0;
        var last = parseInt(read(DISMISSED), 10);
        if (last && (Date.now() - last) / 864e5 < days) return;
        if (views < (parseInt(el.getAttribute('data-axr-views'), 10) || 1)) return;
      }
      var mobile = window.matchMedia('(max-width: 767.98px)').matches;
      var device = el.getAttribute('data-axr-device') || 'all';
      if ((device === 'mobile' && !mobile) || (device === 'desktop' && mobile)) return;

      var done = false, timer = null, offs = [];
      function listen(target, type, fn, opts) { target.addEventListener(type, fn, opts); offs.push(function () { target.removeEventListener(type, fn, opts); }); }
      function show() {
        if (done) return;
        // un altro pop-up o il menu aperto: si aspetta un attimo
        if (document.querySelector('dialog.axr-pop[open], .cc-popup--visible:not([data-section-type="newsletter-popup"])') || body.classList.contains('axr-menu-open')) {
          clearTimeout(timer); timer = setTimeout(show, 3000); return;
        }
        done = true;
        clearTimeout(timer);
        offs.forEach(function (off) { off(); });
        if (typeof el.axrOpen === 'function') el.axrOpen();
        else el.classList.add('cc-popup--visible');
      }

      var delay = parseFloat(el.getAttribute('data-axr-delay')) || 0;
      var pct = parseFloat(el.getAttribute('data-axr-scroll')) || 0;
      var exit = el.getAttribute('data-axr-exit') === 'true';
      if (delay > 0) timer = setTimeout(show, delay * 1000);
      if (pct > 0) {
        listen(window, 'scroll', function () {
          var h = document.documentElement.scrollHeight - window.innerHeight;
          if (h > 0 && window.scrollY / h * 100 >= pct) show();
        }, { passive: true });
      }
      if (exit) {
        if (!mobile) {
          listen(document, 'mouseout', function (evt) {
            if (!evt.relatedTarget && evt.clientY <= 0) show();
          });
        } else {
          var maxY = 0, lastY = window.scrollY, lastT = Date.now();
          listen(window, 'scroll', function () {
            var y = window.scrollY, t = Date.now();
            if (y > maxY) maxY = y;
            // dopo almeno mezza schermata, risalita veloce (più di 1,2 px al millisecondo)
            if (maxY > window.innerHeight * 0.5 && lastY - y > 0 && (lastY - y) / Math.max(t - lastT, 1) > 1.2) show();
            lastY = y; lastT = t;
          }, { passive: true });
        }
      }
      // nessun evento scelto: dopo 8 secondi
      if (!delay && !pct && !exit) timer = setTimeout(show, 8000);
    }
    return { init: init };
  })();

  /* ---------- Pagina prodotto: "Tutti i dettagli" apre e mostra la descrizione ---------- */
  function initHighlights() {
    document.addEventListener('click', function (evt) {
      var more = evt.target.closest('[data-axr-hl-more]');
      if (!more) return;
      var target = document.querySelector(more.getAttribute('href'));
      if (!target) return;
      evt.preventDefault();
      var item = target.querySelector('details.cc-accordion-item');
      var title = item && item.querySelector('.cc-accordion-item__title');
      if (item && title && !item.open) title.click();
      target.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
    });
  }

  /* ---------- Visti di recente: elenco sul dispositivo, schede con dati aggiornati ---------- */
  var Recent = (function () {
    var KEY = 'axr_recent';
    function read() {
      try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
    }
    function write(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 16))); } catch (e) { /* memoria non disponibile */ }
    }
    function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
    function sized(src, w) {
      if (!src) return '';
      if (src.indexOf('//') === 0) src = 'https:' + src;
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }
    function remember() {
      var el = document.querySelector('[data-axr-recent-product]');
      if (!el) return;
      var handle;
      try { handle = JSON.parse(el.textContent); } catch (e) { return; }
      if (!handle) return;
      var list = read().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      write(list);
    }
    function card(p, labels) {
      var li = document.createElement('div');
      li.className = 'axr-recent__item';
      var a = document.createElement('a');
      a.className = 'axr-recent__card';
      a.href = root() + 'products/' + p.handle;
      var media = document.createElement('span');
      media.className = 'axr-recent__media';
      if (p.featured_image) {
        var img = document.createElement('img');
        img.src = sized(p.featured_image, 400);
        img.alt = p.title || '';
        img.loading = 'lazy';
        img.width = 400;
        img.height = 400;
        media.appendChild(img);
      }
      var onSale = isSale(p.price, p.compare_at_price);
      if (onSale && labels.labelSale) {
        var badge = document.createElement('span');
        badge.className = 'axr-recent__badge';
        badge.textContent = labels.labelSale;
        media.appendChild(badge);
      }
      a.appendChild(media);
      var info = document.createElement('span');
      info.className = 'axr-recent__info';
      if (p.vendor) {
        var v = document.createElement('span');
        v.className = 'axr-recent__vendor';
        v.textContent = p.vendor;
        info.appendChild(v);
      }
      var t = document.createElement('span');
      t.className = 'axr-recent__title';
      t.textContent = p.title;
      info.appendChild(t);
      var price = document.createElement('span');
      price.className = 'axr-recent__price';
      var cur = document.createElement('span');
      cur.className = onSale ? 'is-sale' : '';
      cur.textContent = formatMoney(p.price);
      price.appendChild(cur);
      if (onSale) {
        var was = document.createElement('s');
        was.textContent = formatMoney(p.compare_at_price);
        price.appendChild(was);
      }
      info.appendChild(price);
      a.appendChild(info);
      li.appendChild(a);
      return li;
    }
    // Scheda vera del catalogo (etichette, logo della marca, prezzo negozio, "Solo online", omaggi):
    // la genera il tema con sections/axr-card.liquid, chiesta all'indirizzo del prodotto.
    function fullCard(h) {
      return fetch(root() + 'products/' + encodeURIComponent(h) + '?section_id=axr-card', { credentials: 'same-origin' })
        .then(function (r) {
          if (r.status === 404) return { gone: true };
          if (!r.ok) return null;
          return r.text().then(function (html) {
            var tpl = document.createElement('template');
            tpl.innerHTML = html;
            var el = tpl.content.querySelector('.product-block');
            return el ? { el: el } : null;
          });
        })
        .catch(function () { return null; });
    }
    // Ripiego (sezione non disponibile): scheda semplice con i dati del prodotto
    function simpleCard(h, labels) {
      return fetch(root() + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (r) {
          if (r.status === 404) return { gone: true };
          return r.ok ? r.json().then(function (p) { return p && p.handle ? { el: card(p, labels), simple: true } : null; }) : null;
        })
        .catch(function () { return null; });
    }
    function render(section) {
      if (section.dataset.axrRecentDone) return;
      section.dataset.axrRecentDone = '1';
      var listEl = section.querySelector('[data-axr-recent-list]');
      var exclude = section.dataset.exclude || '';
      var limit = parseInt(section.dataset.limit, 10) || 8;
      var handles = read().filter(function (h) { return h && h !== exclude; }).slice(0, limit);
      if (!handles.length || !listEl || !window.fetch) return;
      Promise.all(handles.map(function (h) {
        return fullCard(h).then(function (res) { return res ? res : simpleCard(h, section.dataset); });
      })).then(function (items) {
        // i prodotti non più in vendita escono dall'elenco
        var gone = handles.filter(function (h, i) { return items[i] && items[i].gone; });
        if (gone.length) write(read().filter(function (h) { return gone.indexOf(h) === -1; }));
        var found = items.filter(function (it) { return it && it.el; });
        if (!found.length) return;
        listEl.innerHTML = '';
        found.forEach(function (it) {
          // le schede semplici stanno in un elemento di elenco, quelle vere direttamente nella fila
          listEl.appendChild(it.el);
        });
        section.classList.toggle('axr-recent--simple', found.every(function (it) { return it.simple; }));
        section.hidden = false;
        var wrap = section.querySelector('.axr-rail-wrap');
        if (wrap) {
          initRail(wrap);
          if (wrap.axrRailUpdate) wrap.axrRailUpdate();
        }
      });
      var clear = section.querySelector('[data-axr-recent-clear]');
      if (clear) clear.addEventListener('click', function () { write([]); section.hidden = true; });
    }
    function init(scope) {
      remember();
      (scope || document).querySelectorAll('[data-axr-recent]').forEach(render);
    }
    return { init: init, render: render };
  })();

  /* ---------- Menu mobile Aventurx (pannello a livelli) ---------- */
  var Menu = (function () {
    var root = null;
    var lastFocus = null;
    var closeTimer = null;
    function focusFirst(scope) {
      var el = scope && scope.querySelector('button, a[href], select');
      if (el) el.focus({ preventScroll: true });
    }
    function show(id) {
      var target = root.querySelector('[data-axr-menu-view="' + id + '"]');
      var current = root.querySelector('.axr-menu__view.is-active');
      if (!target || target === current) return;
      var toRoot = id === 'root';
      target.hidden = false;
      void target.offsetWidth; // la transizione parte dalla posizione iniziale
      if (current) {
        current.classList.remove('is-active');
        if (!toRoot) current.classList.add('is-behind');
        if (toRoot) setTimeout(function () { if (!current.classList.contains('is-active')) current.hidden = true; }, reduceMotion.matches ? 0 : 320);
      }
      target.classList.remove('is-behind');
      target.classList.add('is-active');
      target.scrollTop = 0;
      root.querySelectorAll('[data-axr-menu-go]').forEach(function (b) {
        b.setAttribute('aria-expanded', b.getAttribute('data-axr-menu-go') === id ? 'true' : 'false');
      });
      focusFirst(target);
    }
    function reset() {
      root.querySelectorAll('.axr-menu__view').forEach(function (v) {
        var isRoot = v.getAttribute('data-axr-menu-view') === 'root';
        v.classList.toggle('is-active', isRoot);
        v.classList.remove('is-behind');
        v.hidden = !isRoot;
      });
    }
    function open() {
      if (!root) return;
      clearTimeout(closeTimer);
      lastFocus = document.activeElement;
      reset();
      root.hidden = false;
      void root.offsetWidth;
      root.classList.add('is-open');
      body.classList.add('axr-menu-open');
      var close = root.querySelector('.axr-menu__close');
      if (close) close.focus({ preventScroll: true });
    }
    function close() {
      if (!root || root.hidden) return;
      root.classList.remove('is-open');
      body.classList.remove('axr-menu-open');
      closeTimer = setTimeout(function () { root.hidden = true; reset(); }, reduceMotion.matches ? 0 : 320);
      if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    }
    function bind(el) {
      // il pannello sta fuori dall'header (che si sposta scorrendo): resta fisso sullo schermo
      var old = document.querySelectorAll('body > [data-axr-menu]');
      old.forEach(function (o) { if (o !== el) o.remove(); });
      if (el.parentNode !== body) body.appendChild(el);
      root = el;
      root.addEventListener('click', function (evt) {
        var go = evt.target.closest('[data-axr-menu-go]');
        if (go) { show(go.getAttribute('data-axr-menu-go')); return; }
        if (evt.target.closest('[data-axr-menu-back]')) { show('root'); return; }
        if (evt.target.closest('[data-axr-menu-search]')) {
          close();
          // nello stesso tocco, così sul telefono si apre subito la tastiera
          if (Search.open()) return;
          var s = document.querySelector('.section-header .show-search-link');
          if (s) setTimeout(function () { s.click(); }, 60);
          return;
        }
        if (evt.target.closest('[data-axr-menu-close]') || evt.target.closest('[data-axr-pop]')) close();
      });
    }
    function init() {
      var el = document.querySelector('[data-axr-menu]');
      if (el) bind(el);
      // il pulsante ☰ dell'header (e "Categorie" della barra in basso) apre questo menu al posto di quello del tema
      document.addEventListener('click', function (evt) {
        if (!root) return;
        var t = evt.target.closest && evt.target.closest('.mobile-nav-toggle');
        if (t && t.closest('.section-header') && !root.contains(t)) {
          evt.preventDefault();
          evt.stopPropagation();
          open();
        }
      }, true);
      document.addEventListener('keydown', function (evt) {
        if (evt.key === 'Escape' && root && !root.hidden) close();
      });
    }
    function refresh(scope) {
      var el = scope.querySelector && scope.querySelector('[data-axr-menu]');
      if (el) bind(el);
    }
    return { init: init, refresh: refresh, open: open, close: close };
  })();

  /* ---------- Footer Aventurx: colonne a fisarmonica su mobile ---------- */
  function initFooterCols() {
    document.addEventListener('click', function (evt) {
      var btn = evt.target.closest('.axr-footer__col-title');
      if (!btn || !mqMobile.matches) return;
      var col = btn.closest('[data-axr-footer-col]');
      var open = !col.classList.contains('is-open');
      col.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Consegna stimata (stile Amazon): giorni lavorativi in ora italiana ---------- */
  var Delivery = (function () {
    var DAY = 86400000;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function romeNow() {
      var parts = {};
      try {
        new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
          .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
      } catch (e) {
        var d = new Date();
        parts = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate(), hour: d.getHours(), minute: d.getMinutes() };
      }
      return { y: +parts.year, m: +parts.month, d: +parts.day, h: (+parts.hour) % 24, min: +parts.minute };
    }
    // lunedì dell'Angelo (Pasquetta), calendario gregoriano
    function easterMonday(y) {
      var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
      var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
      var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
      var month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
      var dt = new Date(Date.UTC(y, month - 1, day) + DAY);
      return pad(dt.getUTCDate()) + '/' + pad(dt.getUTCMonth() + 1);
    }
    function isWorkday(t, holidays) {
      var dt = new Date(t);
      var wd = dt.getUTCDay();
      if (wd === 0 || wd === 6) return false;
      var key = pad(dt.getUTCDate()) + '/' + pad(dt.getUTCMonth() + 1);
      return holidays.indexOf(key) === -1 && key !== easterMonday(dt.getUTCFullYear());
    }
    function nextWorkday(t, holidays) {
      do { t += DAY; } while (!isWorkday(t, holidays));
      return t;
    }
    function addWorkdays(t, n, holidays) {
      while (n > 0) { t = nextWorkday(t, holidays); n--; }
      return t;
    }
    function fill(box) {
      box.setAttribute('data-axr-filled', '');
      var cutoffEl = box.querySelector('[data-axr-delivery-cutoff]');
      if (box.dataset.mode !== 'date') { if (cutoffEl) cutoffEl.hidden = true; return; }
      var holidays = (box.dataset.holidays || '').split(',').filter(Boolean);
      var cutoff = parseInt(box.dataset.cutoff, 10);
      if (isNaN(cutoff)) cutoff = 19;
      var processing = parseInt(box.dataset.processing, 10) || 0;
      var transit = parseInt(box.dataset.transit, 10) || 1;
      var now = romeNow();
      var today = Date.UTC(now.y, now.m - 1, now.d);
      // giorno in cui l'ordine entra in preparazione
      var start = today;
      if (!isWorkday(today, holidays) || now.h >= cutoff) start = nextWorkday(today, holidays);
      var arrival = addWorkdays(addWorkdays(start, processing, holidays), transit, holidays);
      var dateText;
      try {
        dateText = new Intl.DateTimeFormat(box.dataset.lang || document.documentElement.lang || 'it', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' }).format(new Date(arrival));
      } catch (e) {
        var a = new Date(arrival);
        dateText = pad(a.getUTCDate()) + '/' + pad(a.getUTCMonth() + 1);
      }
      var when = box.querySelector('[data-axr-delivery-when]');
      if (when) {
        var label = box.dataset.labelDate || '__DATE__';
        var i = label.indexOf('__DATE__');
        when.textContent = '';
        when.appendChild(document.createTextNode(label.slice(0, i)));
        var strong = document.createElement('strong');
        strong.textContent = dateText;
        when.appendChild(strong);
        when.appendChild(document.createTextNode(label.slice(i + 8)));
      }
      // conto alla rovescia fino all'ora limite (solo se manca meno di un giorno)
      if (cutoffEl) {
        var minutesLeft = Math.round((start - today) / 60000) + cutoff * 60 - (now.h * 60 + now.min);
        if (minutesLeft > 0 && minutesLeft <= 24 * 60) {
          var h = Math.floor(minutesLeft / 60), m = minutesLeft % 60;
          var time = h > 0 ? (box.dataset.labelHm || '__H__ h __M__ min').replace('__H__', h).replace('__M__', m) : (box.dataset.labelM || '__M__ min').replace('__M__', m);
          var tpl = box.dataset.labelCountdown || '__TIME__';
          var j = tpl.indexOf('__TIME__');
          cutoffEl.textContent = '';
          cutoffEl.appendChild(document.createTextNode(tpl.slice(0, j)));
          var t = document.createElement('strong');
          t.textContent = time;
          cutoffEl.appendChild(t);
          cutoffEl.appendChild(document.createTextNode(tpl.slice(j + 8)));
          cutoffEl.hidden = false;
        } else {
          cutoffEl.hidden = true;
        }
      }
    }
    var timer = null;
    function update() {
      var boxes = document.querySelectorAll('[data-axr-delivery]');
      boxes.forEach(fill);
      // aggiorna data e conto alla rovescia ogni 30 secondi finché c'è un blocco in pagina
      if (boxes.length && !timer) timer = setInterval(update, 30000);
    }
    function fillNew() {
      if (document.querySelector('[data-axr-delivery]:not([data-axr-filled])')) update();
    }
    function init() {
      update();
      // il blocco arriva anche dopo il caricamento: cambio variante (il tema lo ricarica) e acquisto rapido
      if (window.MutationObserver) {
        var pending = false;
        new MutationObserver(function () {
          if (pending) return;
          pending = true;
          setTimeout(function () { pending = false; fillNew(); }, 60);
        }).observe(document.body, { childList: true, subtree: true });
      }
    }
    return { init: init, update: update, _calc: { easterMonday: easterMonday } };
  })();

  /* ---------- Negozi: aperto ora, orari della settimana, distanza, mappa ---------- */
  var Stores = (function () {
    var DAY = 86400000;
    var DAYS = { lun: 1, mar: 2, mer: 3, gio: 4, ven: 5, sab: 6, dom: 0, mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6, sun: 0 };
    var labels = null;
    var cache = [];

    function L() {
      if (labels) return labels;
      var el = document.querySelector('[data-axr-store-labels]');
      try { labels = el ? JSON.parse(el.textContent) : {}; } catch (e) { labels = {}; }
      return labels;
    }
    function fill(str, map) {
      str = String(str || '');
      Object.keys(map).forEach(function (k) { str = str.split(k).join(map[k]); });
      return str;
    }
    function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function fmt(mins) { mins = mins % 1440; return Math.floor(mins / 60) + ':' + pad(mins % 60); }
    function fmtList(list) {
      return list.map(function (r) { return fmt(r[0]) + ' – ' + fmt(r[1]); }).join(', ');
    }

    // ---- lettura degli orari scritti nelle impostazioni ----
    function findDays(seg) {
      var out = [];
      (seg.match(/[a-z]+/g) || []).forEach(function (w) {
        var k = w.slice(0, 3);
        if (w.length >= 3 && Object.prototype.hasOwnProperty.call(DAYS, k)) out.push(DAYS[k]);
      });
      return out;
    }
    function parseDays(s) {
      if (/tutti|ogni giorno|tutta la settimana|every ?day|daily|sempre/.test(s)) return [0, 1, 2, 3, 4, 5, 6];
      var out = [];
      s.split(/,|;|&|\/|\+|\se\s/).forEach(function (seg) {
        var d = findDays(seg);
        if (d.length === 1) out.push(d[0]);
        else if (d.length > 1) {
          // intervallo nell'ordine lunedì → domenica (anche "ven-lun")
          var a = (d[0] + 6) % 7, b = (d[d.length - 1] + 6) % 7;
          for (var i = 0; i < 7; i++) { var x = (a + i) % 7; out.push((x + 1) % 7); if (x === b) break; }
        }
      });
      return out;
    }
    function parseTimes(s) {
      if (/chius|closed|ferm|riposo/.test(s)) return [];
      var out = [], m, re = /(\d{1,2})(?:[:.](\d{2}))?\s*(?:-|–|—|alle|al|to|a)\s*(\d{1,2})(?:[:.](\d{2}))?/g;
      while ((m = re.exec(s))) {
        var a = (+m[1]) * 60 + (+(m[2] || 0)), b = (+m[3]) * 60 + (+(m[4] || 0));
        if (a > 1440 || b > 1440) continue;
        if (b <= a) b += 1440; // oltre la mezzanotte
        out.push([a, b]);
      }
      out.sort(function (x, y) { return x[0] - y[0]; });
      return out.length ? out : null;
    }
    function parseWeek(text) {
      var week = [null, null, null, null, null, null, null], any = false;
      String(text || '').split(/\r?\n/).forEach(function (raw) {
        var s = norm(raw).trim();
        var m = /\d|chius|closed/.exec(s);
        if (!m) return;
        var days = parseDays(s.slice(0, m.index)), times = parseTimes(s.slice(m.index));
        if (!days.length || times === null) return;
        days.forEach(function (d) { week[d] = times; });
        any = true;
      });
      return any ? week : null;
    }
    function fullYear(y) { y = +y; return y < 100 ? 2000 + y : y; }
    function parseSpecial(text) {
      var out = [];
      String(text || '').split(/\r?\n/).forEach(function (raw) {
        var s = norm(raw).trim();
        var m = /^(\d{1,2})[\/.](\d{1,2})(?:[\/.](\d{2,4}))?(?:\s*(?:-|–|—|al)\s*(\d{1,2})[\/.](\d{1,2})(?:[\/.](\d{2,4}))?)?\s*:?\s*(.*)$/.exec(s);
        if (!m) return;
        var times = parseTimes(m[7]);
        if (times === null) return;
        var y1 = m[3] ? fullYear(m[3]) : 0;
        out.push({
          from: (+m[2]) * 100 + (+m[1]), y1: y1,
          to: m[4] ? (+m[5]) * 100 + (+m[4]) : (+m[2]) * 100 + (+m[1]), y2: m[4] ? (m[6] ? fullYear(m[6]) : y1) : y1,
          times: times
        });
      });
      return out;
    }
    function specialMatch(r, y, md) {
      if (r.y1) {
        var v = y * 10000 + md;
        return v >= r.y1 * 10000 + r.from && v <= (r.y2 || r.y1) * 10000 + r.to;
      }
      return r.from <= r.to ? (md >= r.from && md <= r.to) : (md >= r.from || md <= r.to);
    }

    // ---- calcolo dello stato ----
    function nowIn(tz) {
      var p = {};
      try {
        new Intl.DateTimeFormat('en-GB', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
          .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      } catch (e) {
        var d = new Date();
        p = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate(), hour: d.getHours(), minute: d.getMinutes() };
      }
      return { y: +p.year, m: +p.month, d: +p.day, h: (+p.hour) % 24, min: +p.minute };
    }
    function read(el) {
      var hours = el.getAttribute('data-hours') || '', special = el.getAttribute('data-special') || '';
      for (var i = 0; i < cache.length; i++) if (cache[i].hours === hours && cache[i].specialText === special) return cache[i].data;
      var data = { week: parseWeek(hours), special: parseSpecial(special) };
      cache.push({ hours: hours, specialText: special, data: data });
      return data;
    }
    function plan(store, t) {
      var dt = new Date(t), md = (dt.getUTCMonth() + 1) * 100 + dt.getUTCDate(), sp = null;
      store.special.forEach(function (r) { if (specialMatch(r, dt.getUTCFullYear(), md)) sp = r; });
      if (sp) return { list: sp.times, special: true };
      return { list: store.week ? store.week[dt.getUTCDay()] : null, special: false };
    }
    function compute(store, tz) {
      if (!store.week && !store.special.length) return null;
      var now = nowIn(tz), today = Date.UTC(now.y, now.m - 1, now.d), mins = now.h * 60 + now.min, i, r;
      var y = plan(store, today - DAY);
      if (y.list) for (i = 0; i < y.list.length; i++) { r = y.list[i]; if (r[1] > 1440 && mins < r[1] - 1440) return { open: true, end: r[1], left: r[1] - 1440 - mins, today: today, mins: mins }; }
      var p = plan(store, today);
      if (p.list) for (i = 0; i < p.list.length; i++) { r = p.list[i]; if (mins >= r[0] && mins < r[1]) return { open: true, end: r[1], left: r[1] - mins, today: today, mins: mins }; }
      for (var off = 0; off < 9; off++) {
        var q = off === 0 ? p : plan(store, today + off * DAY);
        if (!q.list) continue;
        for (i = 0; i < q.list.length; i++) {
          if (off > 0 || q.list[i][0] > mins) return { open: false, off: off, at: q.list[i][0], day: today + off * DAY, today: today, mins: mins };
        }
      }
      return { open: false, today: today, mins: mins };
    }
    function weekday(t, style) {
      try { return new Intl.DateTimeFormat(L().lang || document.documentElement.lang || 'it', { weekday: style || 'long', timeZone: 'UTC' }).format(new Date(t)); }
      catch (e) { return ''; }
    }
    function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }

    // ---- disegno ----
    function own(el, sel) {
      return Array.prototype.filter.call(el.querySelectorAll(sel), function (x) { return x.closest('[data-axr-store]') === el; });
    }
    function paint(el) {
      var lab = L(), store = read(el);
      var tz = el.getAttribute('data-country') === 'ch' ? 'Europe/Zurich' : 'Europe/Rome';
      var st = compute(store, tz);
      own(el, '[data-axr-store-status]').forEach(function (box) {
        if (!st) { box.hidden = true; return; }
        var text, cls;
        if (st.open) {
          if (st.left <= 45) { text = lab.open + ' · ' + fill(lab.closesIn, { __M__: st.left }); cls = 'is-soon'; }
          else { text = lab.open + ' · ' + fill(lab.closesAt, { __TIME__: fmt(st.end) }); cls = 'is-open'; }
        } else {
          cls = 'is-closed';
          text = lab.closed;
          if (st.day !== undefined) {
            var when = st.off === 0 ? fill(lab.opensAt, { __TIME__: fmt(st.at) })
              : st.off === 1 ? fill(lab.opensTomorrow, { __TIME__: fmt(st.at) })
              : fill(lab.opensDay, { __DAY__: weekday(st.day), __TIME__: fmt(st.at) });
            text += ' · ' + when;
          }
        }
        box.classList.remove('is-open', 'is-soon', 'is-closed');
        box.classList.add(cls);
        var t = box.querySelector('.axr-status__text');
        if (t) t.textContent = text;
        box.hidden = false;
      });
      if (!st) return;
      var todayPlan = plan(store, st.today);
      own(el, '[data-axr-store-today]').forEach(function (t) {
        var v = todayPlan.list === null ? '' : (todayPlan.list.length ? fmtList(todayPlan.list) : lab.closedDay);
        t.textContent = v ? fill(lab.todayHours, { __HOURS__: v }) : '';
      });
      own(el, '[data-axr-store-week]').forEach(function (box) {
        if (!store.week && !store.special.length) return;
        var todayWd = new Date(st.today).getUTCDay(), rows = [], same = true, specialAny = false;
        [1, 2, 3, 4, 5, 6, 0].forEach(function (wd) {
          var t = st.today + ((wd - todayWd + 7) % 7) * DAY, p = plan(store, t);
          rows.push({ t: t, list: p.list, special: p.special, today: t === st.today });
          if (p.special) specialAny = true;
        });
        var key = function (r) { return r.list === null ? '?' : JSON.stringify(r.list); };
        rows.forEach(function (r) { if (key(r) !== key(rows[0])) same = false; });
        var table = document.createElement('table');
        table.className = 'axr-hours__table';
        var tb = document.createElement('tbody');
        function row(label, value, isToday, special) {
          var tr = document.createElement('tr');
          if (isToday) tr.className = 'is-today';
          var th = document.createElement('th');
          th.scope = 'row';
          th.textContent = label;
          if (isToday && lab.today) { var tag = document.createElement('span'); tag.className = 'axr-hours__tag'; tag.textContent = lab.today; th.appendChild(tag); }
          var td = document.createElement('td');
          td.textContent = value;
          if (special && lab.special) { var sp = document.createElement('span'); sp.className = 'axr-hours__special'; sp.textContent = lab.special; td.appendChild(sp); }
          tr.appendChild(th);
          tr.appendChild(td);
          tb.appendChild(tr);
        }
        function val(list) { return list === null ? '—' : (list.length ? fmtList(list) : lab.closedDay); }
        if (same && !specialAny && rows[0].list !== null) row(lab.everyDay, val(rows[0].list), false, false);
        else rows.forEach(function (r) { row(cap(weekday(r.t)), val(r.list), r.today, r.special); });
        table.appendChild(tb);
        box.innerHTML = '';
        box.appendChild(table);
      });
    }

    // ---- elenco negozi: più vicino, filtri, mappa ----
    function haversine(a, b) {
      var R = 6371, rad = Math.PI / 180, dLat = (b[0] - a[0]) * rad, dLon = (b[1] - a[1]) * rad;
      var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a[0] * rad) * Math.cos(b[0] * rad) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
      return 2 * R * Math.asin(Math.sqrt(h));
    }
    function storeEl(scope, n) {
      if (scope.getAttribute && scope.getAttribute('data-axr-store') === String(n)) return scope;
      return scope.querySelector('[data-axr-store="' + n + '"]');
    }
    function initMap(box, scope) {
      if (box.dataset.axrMapReady) return;
      box.dataset.axrMapReady = '1';
      var loaded = false;
      function show(n, load) {
        var card = storeEl(scope, n);
        if (!card) return;
        box.setAttribute('data-selected', n);
        box.querySelectorAll('[data-axr-map-name]').forEach(function (x) { x.textContent = card.getAttribute('data-name') || ''; });
        scope.querySelectorAll('.axr-scard.is-selected').forEach(function (c) { c.classList.remove('is-selected'); });
        if (card.classList.contains('axr-scard')) card.classList.add('is-selected');
        if (load) loaded = true;
        if (!loaded) return;
        var frame = box.querySelector('iframe');
        if (!frame) {
          frame = document.createElement('iframe');
          frame.className = 'axr-map__frame';
          frame.setAttribute('loading', 'lazy');
          frame.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
          frame.setAttribute('allowfullscreen', '');
          box.appendChild(frame);
        }
        frame.title = card.getAttribute('data-name') || '';
        frame.src = 'https://maps.google.com/maps?q=' + (card.getAttribute('data-map-q') || '') + '&z=15&output=embed';
        var ph = box.querySelector('[data-axr-map-ph]');
        if (ph) ph.hidden = true;
        box.classList.add('is-loaded');
      }
      box.addEventListener('click', function (evt) {
        if (evt.target.closest('[data-axr-map-load]')) show(box.getAttribute('data-selected'), true);
      });
      scope.addEventListener('click', function (evt) {
        var sel = evt.target.closest('[data-axr-store-select]');
        if (!sel) return;
        show(sel.getAttribute('data-axr-store-select'), true);
        if (window.matchMedia('(max-width: 1023.98px)').matches) box.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
      });
      box.axrShow = show;
      // la mappa si carica da sola quando entra nello schermo: con il banner dei cookie Aventurx serve il consenso
      // ai contenuti esterni (anche dato dopo, senza ricaricare la pagina), senza banner sempre
      function auto() {
        if (loaded || box.axrAutoIO) return;
        if (window.axrCk && !window.axrCk.has('functional')) return;
        if (!('IntersectionObserver' in window)) { show(box.getAttribute('data-selected'), true); return; }
        box.axrAutoIO = new IntersectionObserver(function (entries) {
          if (!entries.some(function (e) { return e.isIntersecting; })) return;
          box.axrAutoIO.disconnect();
          if (!loaded) show(box.getAttribute('data-selected'), true);
        }, { rootMargin: '300px 0px' });
        box.axrAutoIO.observe(box);
      }
      auto();
      document.addEventListener('axr:consent', auto);
    }
    function initLocator(root) {
      if (root.dataset.axrLocatorReady) return;
      root.dataset.axrLocatorReady = '1';
      var list = root.querySelector('[data-axr-stores-list]');
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-axr-store-item]'));
      var msg = root.querySelector('[data-axr-stores-msg]');
      var near = root.querySelector('[data-axr-stores-near]');
      var mapBox = root.querySelector('[data-axr-store-map]');
      if (mapBox) initMap(mapBox, root);

      root.querySelectorAll('[data-axr-stores-filter]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = btn.getAttribute('data-axr-stores-filter');
          root.querySelectorAll('[data-axr-stores-filter]').forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          items.forEach(function (li) { li.hidden = v !== 'all' && li.getAttribute('data-country') !== v; });
        });
      });

      if (near && list && navigator.geolocation && root.querySelector('[data-axr-store][data-geo]')) {
        near.hidden = false;
        near.addEventListener('click', function () {
          var lab = L();
          if (msg) { msg.hidden = false; msg.textContent = lab.locating || ''; }
          near.disabled = true;
          navigator.geolocation.getCurrentPosition(function (pos) {
            var me = [pos.coords.latitude, pos.coords.longitude];
            items.forEach(function (li) {
              var card = li.querySelector('[data-axr-store]');
              var g = ((card && card.getAttribute('data-geo')) || '').split(',');
              li.axrKm = g.length === 2 && !isNaN(+g[0]) && !isNaN(+g[1]) ? haversine(me, [+g[0], +g[1]]) : Infinity;
              var badge = card && card.querySelector('[data-axr-store-distance]');
              if (badge && li.axrKm !== Infinity) {
                var km = li.axrKm < 10 ? Math.max(1, Math.round(li.axrKm)) : Math.round(li.axrKm / 5) * 5;
                badge.textContent = fill(lab.distance, { __KM__: km });
                badge.hidden = false;
              }
              li.classList.remove('is-nearest');
              var old = li.querySelector('.axr-scard__nearest');
              if (old) old.remove();
            });
            items.slice().sort(function (a, b) { return a.axrKm - b.axrKm; }).forEach(function (li) { list.appendChild(li); });
            var first = list.querySelector('[data-axr-store-item]:not([hidden])');
            if (first) {
              first.classList.add('is-nearest');
              var media = first.querySelector('.axr-scard__media');
              if (media && lab.nearest) {
                var tag = document.createElement('span');
                tag.className = 'axr-scard__nearest';
                tag.textContent = lab.nearest;
                media.appendChild(tag);
              }
              var firstCard = first.querySelector('[data-axr-store]');
              if (mapBox && mapBox.axrShow && firstCard) mapBox.axrShow(firstCard.getAttribute('data-axr-store'), false);
            }
            if (msg) msg.textContent = lab.sorted || '';
            near.disabled = false;
          }, function () {
            if (msg) msg.textContent = lab.geoError || '';
            near.disabled = false;
          }, { timeout: 12000, maximumAge: 600000 });
        });
      }
    }

    var timer = null;
    function update(scope) { (scope || document).querySelectorAll('[data-axr-store]').forEach(paint); }
    function init(scope) {
      scope = scope || document;
      if (!scope.querySelector('[data-axr-store]')) return;
      update(scope);
      scope.querySelectorAll('[data-axr-locator]').forEach(initLocator);
      scope.querySelectorAll('[data-axr-store-map]').forEach(function (box) {
        if (box.closest('[data-axr-locator]')) return;
        initMap(box, box.closest('[data-axr-store]') || document);
      });
      if (!timer) timer = setInterval(function () { update(document); }, 60000);
    }
    return { init: init, _parse: { week: parseWeek, special: parseSpecial } };
  })();

  /* ---------- Ricerca: pannello sopra la pagina con risultati mentre si scrive ---------- */
  var Search = (function () {
    var KEY = 'axr_searches';
    var root = null, panel, form, input, clearBtn, bodyEl, idle, results, statusEl;
    var isOpen = false, ownEntry = false, skipPop = false, lastFocus = null;
    var timer = null, ctrl = null, current = '', cache = {};

    function clean(term) { return String(term || '').replace(/\s+/g, ' ').trim(); }
    function readHistory() {
      try {
        var v = JSON.parse(localStorage.getItem(KEY) || '[]');
        return Array.isArray(v) ? v.filter(function (t) { return typeof t === 'string' && t; }) : [];
      } catch (e) { return []; }
    }
    function writeHistory(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 8))); } catch (e) { /* memoria non disponibile */ }
    }
    function remember(term) {
      term = clean(term).slice(0, 80);
      if (term.length < 2) return;
      var low = term.toLowerCase();
      var list = readHistory().filter(function (t) { return t.toLowerCase() !== low; });
      list.unshift(term);
      writeHistory(list);
    }
    function searchUrl(term) {
      return root.dataset.searchUrl + '?q=' + encodeURIComponent(term) + '&type=' + encodeURIComponent(root.dataset.type || 'product') + '&options%5Bprefix%5D=last';
    }
    function suggestUrl(term) {
      var limit = Math.min(10, Math.max(1, parseInt(root.dataset.limit, 10) || 8));
      return root.dataset.suggestUrl + '?q=' + encodeURIComponent(term) +
        '&section_id=axr-predictive-search' +
        '&resources%5Btype%5D=product%2Ccollection%2Cquery' +
        '&resources%5Blimit%5D=' + limit +
        '&resources%5Blimit_scope%5D=each' +
        '&resources%5Boptions%5D%5Bunavailable_products%5D=last' +
        '&resources%5Boptions%5D%5Bfields%5D=title%2Cproduct_type%2Cvariants.title%2Cvendor%2Cvariants.sku%2Cvariants.barcode%2Ctag';
    }
    // stessa ricerca della pagina risultati, mostrata con la sezione del pannello
    function fullUrl(term) {
      return searchUrl(term) + '&section_id=axr-predictive-search';
    }

    function renderHistory() {
      var box = root.querySelector('[data-axr-search-history]');
      var list = root.querySelector('[data-axr-search-history-list]');
      var tpl = root.querySelector('[data-axr-search-history-tpl]');
      if (!box || !list || !tpl || !tpl.content) return;
      var items = readHistory();
      list.innerHTML = '';
      items.forEach(function (t) {
        var li = tpl.content.firstElementChild.cloneNode(true);
        var a = li.querySelector('a');
        a.href = searchUrl(t);
        a.setAttribute('data-axr-search-term', t);
        a.querySelector('span').textContent = t;
        list.appendChild(li);
      });
      box.hidden = !items.length;
    }
    function renderViewed() {
      var box = root.querySelector('[data-axr-search-viewed]');
      if (box && !box.dataset.axrRecentDone) Recent.render(box);
    }

    function setLoading(state) { root.classList.toggle('is-loading', !!state); }
    function abort() {
      if (ctrl) { try { ctrl.abort(); } catch (e) { /* già chiusa */ } }
      ctrl = null;
    }
    function show(term, html) {
      results.innerHTML = html;
      // senza risultati restano visibili le scorciatoie (più cercate, categorie)
      idle.hidden = !!results.querySelector('.axr-ps__layout');
      bodyEl.scrollTop = 0;
      if (statusEl) {
        var ps = results.querySelector('[data-axr-ps]');
        var empty = results.querySelector('.axr-ps__empty-title');
        statusEl.textContent = empty ? empty.textContent : (results.dataset.labelStatus || '__N__').replace('__N__', ps ? ps.getAttribute('data-count') : '0');
      }
      if (ownEntry) { try { history.replaceState({ axrSearch: true, q: term }, ''); } catch (e) { /* cronologia non disponibile */ } }
    }
    function showError(term) {
      var box = document.createElement('div');
      box.className = 'axr-ps__empty';
      var p = document.createElement('p');
      p.className = 'axr-ps__empty-tip';
      p.textContent = results.dataset.labelError || '';
      var a = document.createElement('a');
      a.className = 'axr-btn axr-btn--dark axr-ps__all';
      a.href = searchUrl(term);
      a.setAttribute('data-axr-search-term', term);
      a.textContent = (results.dataset.labelAll || '__TERMS__').replace('__TERMS__', term);
      box.appendChild(p);
      box.appendChild(a);
      results.innerHTML = '';
      results.appendChild(box);
      idle.hidden = false;
      if (statusEl) statusEl.textContent = p.textContent;
    }
    function fetchPs(url, signal) {
      return fetch(url, { credentials: 'same-origin', signal: signal })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (text) {
          var ps = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-axr-ps]');
          if (!ps) throw new Error('risposta senza risultati');
          return ps;
        });
    }
    // 1) ricerca veloce; 2) senza prodotti, ricerca completa (descrizione, tag, codici) tenendo suggerimenti e
    // categorie già trovati; 3) se non c'è proprio nulla, riprova togliendo l'ultima parola (fino a 3 volte):
    // "giacca dainese donna nera" → "giacca dainese donna". Restituisce { ps, term } con il termine usato.
    function find(term, signal, tries) {
      tries = tries || 0;
      return fetchPs(suggestUrl(term), signal)
        .then(function (ps) {
          if (ps.getAttribute('data-count') !== '0') return ps;
          return fetchPs(fullUrl(term), signal).then(function (full) {
            if (full.getAttribute('data-count') === '0') return ps;
            var side = ps.querySelector('.axr-ps__side');
            var layout = full.querySelector('.axr-ps__layout');
            if (side && layout) layout.insertBefore(side, layout.firstChild);
            return full;
          }, function (err) {
            if (err && err.name === 'AbortError') throw err;
            return ps;
          });
        })
        .then(function (ps) {
          var words = term.split(' ');
          if (ps.querySelector('.axr-ps__layout') || words.length < 2 || tries >= 3) return { ps: ps, term: term };
          return find(words.slice(0, -1).join(' '), signal, tries + 1).then(function (res) {
            return res.ps.querySelector('.axr-ps__layout') ? res : { ps: ps, term: term };
          });
        });
    }
    // avviso in cima ai risultati trovati con meno parole
    function markRelaxed(ps, term, used, label) {
      var note = document.createElement('p');
      note.className = 'axr-ps__relaxed';
      note.textContent = String(label || '').replace('__TERMS__', term).replace('__OTHER__', used);
      ps.insertBefore(note, ps.firstChild);
    }
    function load(term) {
      if (term === current && results.firstChild) return;
      current = term;
      if (Object.prototype.hasOwnProperty.call(cache, term)) { setLoading(false); show(term, cache[term]); return; }
      abort();
      ctrl = window.AbortController ? new AbortController() : null;
      setLoading(true);
      find(term, ctrl ? ctrl.signal : undefined)
        .then(function (res) {
          if (res.term !== term) markRelaxed(res.ps, term, res.term, results.dataset.labelRelaxed);
          cache[term] = res.ps.outerHTML;
          if (term !== current) return;
          setLoading(false);
          show(term, cache[term]);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          if (term !== current) return;
          setLoading(false);
          showError(term);
        });
    }
    // pagina risultati senza prodotti: mostra i risultati con meno parole, se ce ne sono
    function similar() {
      var box = document.querySelector('[data-axr-search-similar]');
      var term = box && clean(box.getAttribute('data-terms'));
      if (!term || term.indexOf(' ') < 0) return;
      find(term).then(function (res) {
        if (res.term === term || !res.ps.querySelector('.axr-ps__layout')) return;
        markRelaxed(res.ps, term, res.term, box.getAttribute('data-label'));
        box.appendChild(res.ps);
        box.hidden = false;
      }).catch(function () { /* resta il messaggio senza risultati */ });
    }
    function update(immediate) {
      var term = clean(input.value);
      clearBtn.hidden = !input.value;
      root.classList.toggle('has-term', !!term);
      clearTimeout(timer);
      if (!term) {
        current = '';
        abort();
        setLoading(false);
        results.innerHTML = '';
        idle.hidden = false;
        if (ownEntry) { try { history.replaceState({ axrSearch: true, q: '' }, ''); } catch (e) { /* cronologia non disponibile */ } }
        return;
      }
      timer = setTimeout(function () { load(term); }, immediate ? 0 : 160);
    }

    function open(term, opts) {
      if (!root) return false;
      opts = opts || {};
      if (!isOpen) {
        lastFocus = document.activeElement;
        root.hidden = false;
        void root.offsetWidth; // la transizione parte dallo stato chiuso
        isOpen = true;
        root.classList.add('is-open');
        body.classList.add('axr-search-active');
        renderHistory();
        renderViewed();
        // il tasto "indietro" del telefono chiude il pannello invece di lasciare la pagina
        if (opts.restore) {
          ownEntry = true;
        } else {
          try { history.pushState({ axrSearch: true, q: '' }, ''); ownEntry = true; } catch (e) { ownEntry = false; }
        }
      }
      var given = typeof term === 'string';
      if (given) input.value = term;
      update(true);
      if (!opts.noFocus) {
        input.focus({ preventScroll: true });
        // testo arrivato dalla pagina risultati: cursore in fondo per correggerlo;
        // ricerca rimasta da prima: selezionata, così scrivendo si sostituisce
        try {
          if (given) { var n = input.value.length; input.setSelectionRange(n, n); }
          else if (input.value) input.select();
        } catch (e) { /* campo senza selezione */ }
      }
      return true;
    }
    function close(fromHistory) {
      if (!isOpen) return;
      isOpen = false;
      clearTimeout(timer);
      abort();
      setLoading(false);
      root.classList.remove('is-open');
      body.classList.remove('axr-search-active');
      if (document.activeElement === input) input.blur();
      setTimeout(function () { if (!isOpen) root.hidden = true; }, reduceMotion.matches ? 0 : 220);
      if (lastFocus && lastFocus.focus && document.contains(lastFocus) && !lastFocus.matches('input')) {
        try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* elemento non più attivo */ }
      }
      lastFocus = null;
      if (ownEntry && !fromHistory) {
        skipPop = true;
        try { history.back(); } catch (e) { skipPop = false; }
      }
      ownEntry = false;
    }

    function visible(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }
    function navItems() {
      var scope = idle.hidden ? results : bodyEl;
      return Array.prototype.filter.call(scope.querySelectorAll('a[href], button'), visible);
    }
    function onKey(evt) {
      if (evt.key === 'Escape') { evt.preventDefault(); close(); return; }
      if (evt.key === 'ArrowDown' || evt.key === 'ArrowUp') {
        var list = navItems();
        var i = list.indexOf(document.activeElement);
        var next = null;
        if (evt.key === 'ArrowDown') next = document.activeElement === input ? list[0] : list[i + 1];
        else if (i > -1) next = i === 0 ? input : list[i - 1];
        if (next) { evt.preventDefault(); next.focus(); }
        return;
      }
      if (evt.key === 'Tab') {
        // il fuoco resta dentro il pannello
        var all = Array.prototype.filter.call(panel.querySelectorAll('a[href], button, input:not([type="hidden"])'), visible);
        if (!all.length) return;
        var first = all[0], last = all[all.length - 1];
        if (evt.shiftKey && document.activeElement === first) { evt.preventDefault(); last.focus(); }
        else if (!evt.shiftKey && document.activeElement === last) { evt.preventDefault(); first.focus(); }
      }
    }

    function bind() {
      root.addEventListener('click', function (evt) {
        var t = evt.target;
        if (t.closest('[data-axr-search-close]')) { evt.preventDefault(); close(); return; }
        if (t.closest('[data-axr-search-clear]')) { input.value = ''; update(true); input.focus(); return; }
        if (t.closest('[data-axr-search-history-clear]')) { writeHistory([]); renderHistory(); return; }
        var fill = t.closest('[data-axr-search-fill]');
        if (fill) { input.value = fill.getAttribute('data-axr-search-fill') + ' '; input.focus(); update(true); return; }
        var termLink = t.closest('[data-axr-search-term]');
        if (termLink) { remember(termLink.getAttribute('data-axr-search-term')); return; }
        if (t.closest('.axr-ps__product, .axr-search__chip, .axr-search__cat, .axr-recent__card')) remember(input.value);
      });
      input.addEventListener('input', function () { update(false); });
      form.addEventListener('submit', function (evt) {
        var term = clean(input.value);
        if (!term) { evt.preventDefault(); input.focus(); return; }
        input.value = term;
        remember(term);
      });
      root.addEventListener('keydown', onKey);
    }

    function init() {
      root = document.querySelector('[data-axr-search]');
      if (!root) return;
      if (root.parentNode !== body) body.appendChild(root);
      panel = root.querySelector('.axr-search__panel');
      form = root.querySelector('[data-axr-search-form]');
      input = root.querySelector('[data-axr-search-input]');
      clearBtn = root.querySelector('[data-axr-search-clear]');
      bodyEl = root.querySelector('.axr-search__body');
      idle = root.querySelector('[data-axr-search-idle]');
      results = root.querySelector('[data-axr-search-results]');
      statusEl = root.querySelector('[data-axr-search-status]');
      if (!panel || !form || !input || !clearBtn || !bodyEl || !idle || !results) { root = null; return; }
      bind();
      similar();

      // lente e barra dell'header, "Cerca" della barra in basso, barra della pagina risultati:
      // aprono questo pannello al posto della ricerca del tema (che nasconde tutta la pagina)
      document.addEventListener('click', function (evt) {
        var t = evt.target.closest && evt.target.closest('.show-search-link, [data-axr-open-search], [data-axr-search-open]');
        if (!t || root.contains(t) || evt.metaKey || evt.ctrlKey) return;
        evt.preventDefault();
        evt.stopPropagation();
        open(t.hasAttribute('data-axr-search-value') ? t.getAttribute('data-axr-search-value') : undefined);
      }, true);

      // "indietro": chiude il pannello; tornando su una voce della ricerca (es. da un prodotto) lo riapre.
      // In fase di cattura, così i filtri AJAX del tema non ricaricano i prodotti per le voci della ricerca.
      window.addEventListener('popstate', function (evt) {
        if (skipPop) { skipPop = false; evt.stopImmediatePropagation(); return; }
        if (isOpen) { evt.stopImmediatePropagation(); close(true); return; }
        if (evt.state && evt.state.axrSearch) { evt.stopImmediatePropagation(); open(evt.state.q || '', { restore: true, noFocus: true }); }
      }, true);
      window.addEventListener('pageshow', function (evt) { if (evt.persisted) setLoading(false); });
      if (history.state && history.state.axrSearch) open(history.state.q || '', { restore: true, noFocus: true });

      // la ricerca fatta (anche dalla pagina dei risultati) entra tra le recenti
      var top = document.querySelector('[data-axr-search-open][data-axr-search-value]');
      if (top) remember(top.getAttribute('data-axr-search-value'));
    }
    return { init: init, open: function (term) { return open(term); } };
  })();

  /* ---------- Pagina Marche: cerca una marca, lettere A–Z, lettera attiva mentre si scorre ---------- */
  var Brands = (function () {
    function norm(s) {
      s = String(s || '');
      if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
      return s.toLowerCase().replace(/[^a-z0-9]/g, '');
    }
    function fillTemplate(el, q, source) {
      var tpl = (source || el).getAttribute('data-template') || '__Q__';
      el.textContent = tpl.replace('__Q__', q);
    }
    function setup(root) {
      if (root.dataset.axrBrandsInit) return;
      root.dataset.axrBrandsInit = '1';
      var input = root.querySelector('[data-axr-brands-input]');
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-axr-brand]'));
      var groups = Array.prototype.slice.call(root.querySelectorAll('[data-axr-brands-group]'));
      var featured = root.querySelector('[data-axr-brands-featured]');
      var nav = root.querySelector('[data-axr-brands-nav]');
      var all = root.querySelector('[data-axr-brands-all]');
      var count = root.querySelector('[data-axr-brands-count]');
      var empty = root.querySelector('[data-axr-brands-empty]');
      var keys = items.map(function (li) { return norm(li.getAttribute('data-axr-brand')); });

      function filter() {
        var raw = input.value.trim();
        var q = norm(raw);
        var shown = 0;
        items.forEach(function (li, i) {
          var ok = !q || keys[i].indexOf(q) > -1;
          li.hidden = !ok;
          if (ok) shown++;
        });
        groups.forEach(function (g) { g.hidden = !g.querySelector('[data-axr-brand]:not([hidden])'); });
        if (featured) featured.hidden = !!q;
        if (nav) nav.hidden = !!q;
        if (all) all.hidden = shown === 0;
        if (count) {
          count.textContent = q ? (count.getAttribute('data-label-found') || '__N__').replace('__N__', shown) : count.getAttribute('data-label-all');
        }
        if (empty) {
          empty.hidden = shown > 0;
          if (!shown) {
            var text = empty.querySelector('[data-axr-brands-empty-text]');
            var link = empty.querySelector('[data-axr-brands-search]');
            if (text) fillTemplate(text, raw);
            if (link) {
              var label = link.querySelector('span');
              if (label) fillTemplate(label, raw, link);
              link.href = link.getAttribute('href').split('?')[0] + '?q=' + encodeURIComponent(raw);
            }
          }
        }
      }
      if (input) {
        input.addEventListener('input', filter);
        input.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter') return;
          e.preventDefault();
          var first = root.querySelector('[data-axr-brand]:not([hidden]) a');
          if (first && input.value.trim()) first.focus();
        });
        if (input.value) filter();
      }

      if (!nav) return;
      var list = nav.querySelector('ul');
      var links = {};
      nav.querySelectorAll('a[href^="#"]').forEach(function (a) {
        links[a.getAttribute('href').slice(1)] = a;
        a.addEventListener('click', function (e) {
          var target = document.getElementById(a.getAttribute('href').slice(1));
          if (!target) return;
          e.preventDefault();
          target.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
        });
      });
      if (!('IntersectionObserver' in window)) return;
      // la lettera del gruppo che passa a metà schermo si accende nella barra
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var a = links[entry.target.id];
          if (!a || a.classList.contains('is-current')) return;
          nav.querySelectorAll('.is-current').forEach(function (x) { x.classList.remove('is-current'); });
          a.classList.add('is-current');
          if (list && list.scrollWidth > list.clientWidth) {
            list.scrollLeft = a.offsetLeft - list.offsetLeft - (list.clientWidth - a.offsetWidth) / 2;
          }
        });
      }, { rootMargin: '-40% 0px -55% 0px' });
      groups.forEach(function (g) { io.observe(g); });
    }
    function init(scope) {
      (scope || document).querySelectorAll('[data-axr-brands]').forEach(setup);
    }
    return { init: init };
  })();

  /* ---------- Buono regalo: anteprima con importo, nome e messaggio del destinatario ---------- */
  var GiftCard = (function () {
    function setup(box) {
      if (box.dataset.axrGcInit) return;
      box.dataset.axrGcInit = '1';
      var scope = box.closest('.shopify-section') || document;
      var card = box.querySelector('[data-axr-gc-card]');
      var stage = box.querySelector('[data-axr-gc-stage]');
      var amount = box.querySelector('[data-axr-gc-amount]');
      var to = box.querySelector('[data-axr-gc-to]');
      var msg = box.querySelector('[data-axr-gc-msg]');
      var prices = {};
      try { prices = JSON.parse(box.querySelector('[data-axr-gc-prices]').textContent); } catch (e) { /* si usa il nome della variante */ }
      if (!card) return;

      function flash() {
        card.classList.remove('is-bump');
        void card.offsetWidth;
        card.classList.add('is-bump');
      }
      scope.addEventListener('on:variant:change', function (evt) {
        var v = evt.detail && evt.detail.variant;
        if (!v || !amount) return;
        var text = prices[v.id] || v.public_title || v.title || formatMoney(v.price);
        if (amount.textContent !== text) {
          amount.textContent = text;
          flash();
        }
      });

      var checkbox = scope.querySelector('.cc-gift-card-recipient__checkbox');
      var nameInput = scope.querySelector('[name="properties[Recipient name]"]');
      var msgInput = scope.querySelector('[name="properties[Message]"]');
      function paint() {
        var on = !!(checkbox && checkbox.checked);
        var name = on && nameInput ? nameInput.value.trim() : '';
        var text = on && msgInput ? msgInput.value.trim() : '';
        if (to) to.textContent = name ? (to.getAttribute('data-template') || '__NAME__').replace('__NAME__', name) : to.getAttribute('data-default');
        if (msg) {
          msg.textContent = text;
          msg.hidden = !text;
        }
        box.classList.toggle('is-personal', !!name);
      }
      [nameInput, msgInput].forEach(function (el) { if (el) el.addEventListener('input', paint); });
      if (checkbox) checkbox.addEventListener('change', paint);
      paint();

      // la carta si inclina seguendo il mouse (non su touch e non se si riducono le animazioni)
      if (!stage || reduceMotion.matches || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      var frame = 0;
      stage.addEventListener('pointermove', function (e) {
        if (frame) return;
        frame = requestAnimationFrame(function () {
          frame = 0;
          var r = stage.getBoundingClientRect();
          var x = Math.min(Math.max((e.clientX - r.left) / r.width, 0), 1) - 0.5;
          var y = Math.min(Math.max((e.clientY - r.top) / r.height, 0), 1) - 0.5;
          card.style.setProperty('--rx', (-y * 10).toFixed(2) + 'deg');
          card.style.setProperty('--ry', (x * 14).toFixed(2) + 'deg');
          card.style.setProperty('--gx', ((x + 0.5) * 100).toFixed(1) + '%');
          card.style.setProperty('--gy', ((y + 0.5) * 100).toFixed(1) + '%');
        });
      });
      stage.addEventListener('pointerleave', function () {
        ['--rx', '--ry', '--gx', '--gy'].forEach(function (p) { card.style.removeProperty(p); });
      });
    }
    function init(scope) {
      (scope || document).querySelectorAll('[data-axr-gc]').forEach(setup);
    }
    return { init: init };
  })();

  /* ---------- Scheda premium: pulsante "Acquista" e video che parte quando è sullo schermo ---------- */
  var Premium = (function () {
    function scrollToBuy() {
      var section = document.querySelector('[data-section-type="main-product"]');
      if (!section) return false;
      // su telefono si va al modulo d'acquisto (sotto le foto), su computer all'inizio della scheda
      var target = (mqMobile.matches && section.querySelector('.product-form')) || section;
      var offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--axr-toolbar-top'), 10) || 0;
      window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - offset - 12, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      return true;
    }
    function setup(root) {
      if (root.dataset.axrPremInit) return;
      root.dataset.axrPremInit = '1';
      root.querySelectorAll('[data-axr-prem-buy]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          if (scrollToBuy()) e.preventDefault();
        });
      });
      // scheda tecnica lunga: su telefono si apre con "Mostra di più"
      root.querySelectorAll('[data-axr-prem-group]').forEach(function (group) {
        var btn = group.querySelector('[data-axr-prem-more]');
        if (!btn) return;
        var label = btn.querySelector('span');
        var more = label ? label.textContent : '';
        group.classList.add('is-collapsed');
        btn.hidden = false;
        btn.addEventListener('click', function () {
          var open = group.classList.toggle('is-collapsed') === false;
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (label) label.textContent = open ? btn.getAttribute('data-label-less') : more;
          if (!open) group.scrollIntoView({ block: 'nearest', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        });
      });
      var video = root.querySelector('[data-axr-prem-video] video');
      if (!video || reduceMotion.matches || !('IntersectionObserver' in window)) return;
      var manual = false;
      video.addEventListener('pointerdown', function () { manual = true; });
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (manual) return;
          if (entry.isIntersecting) {
            video.muted = true;
            var playing = video.play();
            if (playing && playing.catch) playing.catch(function () { /* il browser blocca l'avvio: restano i comandi */ });
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.5 }).observe(video);
    }
    function init(scope) {
      (scope || document).querySelectorAll('[data-axr-prem]').forEach(setup);
    }
    return { init: init };
  })();

  /* ---------- Tabelle nei testi (pagine, descrizioni): scorrono di lato sul telefono ---------- */
  function initTables(root) {
    root.querySelectorAll('.rte table').forEach(function (t) {
      if (t.dataset.axrTable || t.getAttribute('style') || t.closest('.axr-table-scroll')) return;
      var parent = t.parentElement;
      // le tabelle già preparate (es. guide taglie con scorrimento proprio) restano come sono
      if (parent && /overflow/.test(parent.getAttribute('style') || '')) return;
      t.dataset.axrTable = '1';
      var wrap = document.createElement('div');
      wrap.className = 'axr-table-scroll';
      t.parentNode.insertBefore(wrap, t);
      wrap.appendChild(t);
    });
  }

  /* ---------- Avvio ---------- */
  /* ---------- Loghi delle marche: tolgono da soli il margine vuoto attorno al logo ---------- */
  // Il logo è l'immagine della collezione della marca, spesso disegnata con molto spazio intorno: qui si trova
  // il riquadro del disegno (pixel non trasparenti e non bianchi) e si mostra solo quello, all'altezza prevista.
  // Il risultato si ricorda sul dispositivo; se l'immagine non si può leggere resta intera.
  var VendorLogos = (function () {
    var KEY = 'axr_vlogo_v1';
    var boxes = null;
    function load() {
      if (boxes) return boxes;
      try { boxes = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { boxes = {}; }
      return boxes;
    }
    function save() {
      try {
        var keys = Object.keys(boxes);
        if (keys.length > 300) keys.slice(0, keys.length - 300).forEach(function (k) { delete boxes[k]; });
        localStorage.setItem(KEY, JSON.stringify(boxes));
      } catch (e) { /* memoria non disponibile */ }
    }
    function keyOf(src) { return String(src).split('?')[0].replace(/_\d+x\d*(?=\.)/, ''); }
    // riquadro del disegno, in frazioni dell'immagine: [x, y, larghezza, altezza]; 0 = logo tutto chiaro
    function measure(src, done) {
      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        try {
          var w = Math.min(240, probe.naturalWidth || 240);
          var h = Math.max(1, Math.round(w * (probe.naturalHeight / probe.naturalWidth)));
          var c = document.createElement('canvas');
          c.width = w; c.height = h;
          var ctx = c.getContext('2d');
          ctx.drawImage(probe, 0, 0, w, h);
          var px = ctx.getImageData(0, 0, w, h).data;
          var x0 = w, y0 = h, x1 = -1, y1 = -1, light = 0;
          for (var y = 0; y < h; y++) {
            for (var x = 0; x < w; x++) {
              var i = (y * w + x) * 4;
              if (px[i + 3] < 40) continue;
              if (px[i] > 232 && px[i + 1] > 232 && px[i + 2] > 232) { light++; continue; }
              if (x < x0) x0 = x;
              if (x > x1) x1 = x;
              if (y < y0) y0 = y;
              if (y > y1) y1 = y;
            }
          }
          if (x1 < 0) { done(light ? 0 : null); return; }
          var pad = 1;
          x0 = Math.max(0, x0 - pad); y0 = Math.max(0, y0 - pad);
          x1 = Math.min(w - 1, x1 + pad); y1 = Math.min(h - 1, y1 + pad);
          done([x0 / w, y0 / h, (x1 - x0 + 1) / w, (y1 - y0 + 1) / h].map(function (v) { return Math.round(v * 10000) / 10000; }));
        } catch (e) { done(null); }
      };
      probe.onerror = function () { done(null); };
      probe.src = src;
    }
    // al posto del logo resta il nome scritto; nella testata della pagina marca il nome c'è già nel titolo: via il riquadro
    function toText(img) {
      var wrap = img.parentNode;
      if (!wrap || !wrap.classList || !wrap.classList.contains('axr-vlogo')) return;
      var hero = wrap.closest('.axr-brandtop__logo');
      if (hero) { hero.style.display = 'none'; return; }
      wrap.outerHTML = '<span class="axr-vlogo-text">' + String(img.alt || '').replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }) + '</span>';
    }
    // logo che il browser non riesce a caricare: si riprova una volta con un indirizzo nuovo (una copia rotta
    // rimasta nella memoria del browser non conta più), poi resta il nome scritto invece dell'immagine rotta
    function fail(img) {
      if (img.dataset.axrVlogoRetry) { toText(img); return; }
      var src = img.getAttribute('src') || '';
      if (!src) { toText(img); return; }
      img.dataset.axrVlogoRetry = '1';
      img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'axr=1';
    }
    function apply(img, box) {
      var wrap = img.parentNode;
      if (!wrap || !wrap.classList.contains('axr-vlogo')) return;
      if (box === 0) {
        // logo bianco: su sfondo chiaro non si vedrebbe, torna il nome scritto
        toText(img);
        return;
      }
      if (!box) return;
      var cs = getComputedStyle(wrap);
      var H = parseFloat(cs.getPropertyValue('--axr-vlogo-h')) || wrap.clientHeight || 20;
      var maxW = parseFloat(cs.getPropertyValue('--axr-vlogo-w')) || 120;
      var ratio = (img.naturalWidth || img.width) / (img.naturalHeight || img.height || 1);
      var area = parseFloat(cs.getPropertyValue('--axr-vlogo-area'));
      var fullH, fullW;
      if (area > 0) {
        // schede: tutti i loghi con la stessa superficie, così un logo lungo e basso (AIROH) pesa come uno
        // tondo o compatto (HJC); sempre dentro il riquadro alto H e largo al massimo maxW
        var r = box[2] / box[3] * ratio;
        var drawH = Math.min(H, Math.sqrt(area / r));
        if (drawH * r > maxW) drawH = maxW / r;
        fullH = drawH / box[3];
        fullW = fullH * ratio;
      } else {
        fullH = H / box[3];
        fullW = fullH * ratio;
        if (box[2] * fullW > maxW) { var k = maxW / (box[2] * fullW); fullW *= k; fullH *= k; }
      }
      img.style.width = fullW.toFixed(1) + 'px';
      img.style.height = fullH.toFixed(1) + 'px';
      img.style.left = (-box[0] * fullW).toFixed(1) + 'px';
      img.style.top = (-box[1] * fullH + (H - box[3] * fullH) / 2).toFixed(1) + 'px';
      wrap.style.setProperty('--axr-vlogo-w-now', (box[2] * fullW).toFixed(1) + 'px');
      wrap.classList.add('is-trimmed');
    }
    function process(img) {
      if (img.dataset.axrVlogoDone) return;
      img.dataset.axrVlogoDone = '1';
      var key = keyOf(img.currentSrc || img.src);
      var known = load()[key];
      if (known !== undefined) { apply(img, known); return; }
      measure(img.currentSrc || img.src, function (box) {
        if (box !== null) { boxes[key] = box; save(); }
        apply(img, box);
      });
    }
    function scan(root) {
      (root || document).querySelectorAll('img[data-axr-vlogo]').forEach(function (img) {
        if (!img.complete) return;
        if (img.naturalWidth) process(img);
        else if (img.currentSrc || img.getAttribute('src')) fail(img); // non caricato prima che partisse lo script
      });
    }
    function init() {
      // anche per le schede caricate dopo (filtri, scorrimento infinito, visti di recente)
      document.addEventListener('load', function (evt) {
        var t = evt.target;
        if (t && t.tagName === 'IMG' && t.hasAttribute('data-axr-vlogo')) process(t);
      }, true);
      document.addEventListener('error', function (evt) {
        var t = evt.target;
        if (t && t.tagName === 'IMG' && t.hasAttribute('data-axr-vlogo')) fail(t);
      }, true);
      scan(document);
    }
    return { init: init, scan: scan };
  })();

  /* ---------- Omaggi: aggiunta gratuita, un solo omaggio per ordine, tolto se la spesa scende sotto la soglia ---------- */
  // Lo stato (spesa valida, soglia, righe omaggio) arriva da sections/axr-gift-state.liquid; il prezzo zero lo fa
  // lo sconto automatico di Shopify. Si controlla dopo ogni modifica del carrello, anche fatta da app.
  var Gifts = (function () {
    var rawFetch = window.fetch ? window.fetch.bind(window) : null;
    var timer = null, busy = false, fixes = 0;
    function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
    function json(url, body) {
      return rawFetch(root() + url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); });
    }
    function state() {
      return rawFetch(root() + '?section_id=axr-gift-state', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (text) {
          var el = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-axr-gift-state]');
          var raw = el ? el.textContent.trim() : '';
          try { return raw ? JSON.parse(raw) : null; } catch (e) { return null; }
        });
    }
    function cartChanged(open) {
      document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false, detail: open ? { openDrawer: true } : {} }));
    }
    function check() {
      // al massimo 3 correzioni per pagina: se il carrello non cambia non si insiste
      if (busy || !rawFetch || fixes >= 3) return;
      busy = true;
      state().then(function (st) {
        if (!st || !st.on || !st.keys || !st.keys.length) return false;
        // "fix": omaggi da togliere (soglia della loro promo non raggiunta, o un secondo omaggio della stessa promo)
        // o da riportare a 1 pezzo, scritti come "chiave@quantità"
        var ops = [];
        (st.fix || []).forEach(function (f) {
          var at = f.lastIndexOf('@');
          if (at > 0) ops.push([f.slice(0, at), parseInt(f.slice(at + 1), 10) || 0]);
        });
        if (!ops.length) return false;
        fixes++;
        return ops.reduce(function (p, op) {
          return p.then(function () { return json('cart/change.js', { id: op[0], quantity: op[1] }); });
        }, Promise.resolve()).then(function () { return true; });
      }).then(function (changed) {
        busy = false;
        if (changed) cartChanged(false);
      }).catch(function () { busy = false; });
    }
    function schedule(ms) {
      clearTimeout(timer);
      timer = setTimeout(check, ms || 700);
    }
    function add(btn) {
      var id = parseInt(btn.getAttribute('data-axr-gift-add'), 10);
      if (!id || !rawFetch) return;
      btn.classList.add('is-loading');
      busy = true;
      // un omaggio per promo (omaggi generali, o la singola marca): quello scelto prende il posto del precedente della stessa promo
      var group = btn.getAttribute('data-axr-gift-group') || 'global';
      state().then(function (st) {
        var p = Promise.resolve();
        var old = [];
        if (st && st.items) {
          st.items.forEach(function (it) {
            var gt = it.lastIndexOf('>');
            if (gt > 0 && it.slice(gt + 1) === group) old.push(it.slice(0, gt));
          });
        } else if (st && st.keys) old = st.keys;
        old.forEach(function (k) { p = p.then(function () { return json('cart/change.js', { id: k, quantity: 0 }); }); });
        return p.then(function () { return json('cart/add.js', { items: [{ id: id, quantity: 1 }] }); });
      }).then(function () {
        busy = false;
        btn.classList.remove('is-loading');
        if (window.theme && theme.settings && theme.settings.cart_type === 'page') { window.location = root() + 'cart'; return; }
        cartChanged(true);
      }).catch(function () {
        busy = false;
        btn.classList.remove('is-loading');
      });
    }
    function init() {
      if (!(window.theme && theme.axrGift)) return;
      document.addEventListener('click', function (evt) {
        var btn = evt.target.closest && evt.target.closest('[data-axr-gift-add]');
        if (!btn) return;
        evt.preventDefault();
        add(btn);
      });
      // pagina di un omaggio con più varianti (taglie): il pulsante segue la variante scelta
      document.addEventListener('on:variant:change', function (evt) {
        var v = evt.detail && evt.detail.variant;
        var detail = evt.target && evt.target.closest ? evt.target.closest('.product-detail') : null;
        var btn = detail && detail.querySelector('[data-axr-gift-pick]');
        if (!btn || !v) return;
        btn.setAttribute('data-axr-gift-add', v.id);
        btn.disabled = !v.available;
      }, true);
      document.addEventListener('theme:cartchanged', function () { if (!busy) schedule(700); });
      // carrelli aggiornati da app (cassetto del carrello esterno): si osservano le chiamate al carrello
      if (rawFetch && !window.fetch.__axrGift) {
        var wrapped = function (input) {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          var res = rawFetch.apply(window, arguments);
          if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url) && !busy) res.then(function () { schedule(900); }, function () {});
          return res;
        };
        wrapped.__axrGift = true;
        window.fetch = wrapped;
      }
      schedule(400);
    }
    return { init: init };
  })();

  function initAll(scope) {
    var root = scope || document;
    initTables(root);
    root.querySelectorAll('.axr-rail-wrap').forEach(initRail);
    root.querySelectorAll('[data-axr-tabs]').forEach(initTabs);
    root.querySelectorAll('[data-axr-hero]').forEach(initHero);
    initCollectionToolbar(root);
    initClamp(root);
  }

  onReady(function () {
    initAutohideHeader();
    initBottomNav();
    initSearchState();
    initFooterAccordion();
    initStickyAtc();
    Moto.init();
    Pop.init();
    Menu.init();
    initFooterCols();
    initHighlights();
    Recent.init(document);
    Delivery.init();
    Search.init();
    Stores.init(document);
    Brands.init(document);
    GiftCard.init(document);
    Premium.init(document);
    VendorLogos.init();
    Gifts.init();
    PopupRules.init();
    Chat.init();
    initAll(document);
  });

  // Editor del tema: reinizializza le sezioni ricaricate
  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target);
    Moto.refresh(evt.target);
    evt.target.querySelectorAll('[data-axr-recent]').forEach(Recent.render);
    Stores.init(evt.target);
    Brands.init(evt.target);
    GiftCard.init(evt.target);
    Premium.init(evt.target);
    VendorLogos.scan(evt.target);
    Menu.refresh(evt.target);
  });
})();
